import axios 			from 'axios'
import io 				from 'socket.io-client';
import moment  			from 'moment';
// import show_data 	from '@/components/lpr/show_data.vue'
import SimpleKeyboard 	from "@/components/simple_Keyboard.vue";
import EventBus  		from '@/event-bus'
import date_range 		from '@/components/info/date_range.vue';
import alert 	 		from '@/components/info/alert.vue';
import CounterEventDetailsModal from '@/components/Modals/CounterEventDetailsModal.vue';
// import test 			from '@/components/tester/jsons/lpr_socket.json'
import searcher 		from "@/components/info/searcher.vue"
import dates 			from "@/components/info/dates.vue"
import default_tags  	from "@/components/analytics/default_tags.js"
// import testEvents 		from "@/components/events/js/testEventsAlarms.js"
import CounterCell from '../CounterCell.vue';
import { formatAccessControlEvent } from '@/components/access-control/accessControlEvents.js';


	export default {
		name: 'events',
		props:[
			'layout', 
			'layout_id', 
			'host_from', 
			'report_list', 
			'is_reports', 
			'total_report',
			'ref_to_component',
			'info_to_component',
			'resize_to_component',
			'info_logs',
		],
		components: {
			moment, 
			// show_data, 
			SimpleKeyboard,
			date_range,			
			alert,
			CounterEventDetailsModal,
			searcher,
			dates,
			CounterCell,
		},
		data: (vm) => ({
			moment 	: moment,
			headers : [], //headers table
			items : { 
				'plate': 'ssd45' ,
				'host': 'host1',
				'manager': 'Manager' ,
				'date': '2020-01-04 01:00:30' ,
				'speed': '30 km/h' ,
				'speed_limit': '66 km/h'
			},// items
			
			list 			: [],
			list_off 		: [],
			info_to_modal 	: null,
			tab 			: null,
			height 			: 300,
			options 		: { itemsPerPage:30 },
			total 			: 1,
			last_total 		: 0,
			search 			: null,
			input 			: '',
			loading 		: false,
			list_search 	: [],
			options_search  : {},
			total_search 	: 0	,
			status_message 	:'',
			color_message 	:'',
			// status_message1:'',
			theme 			: 'hg-theme-default myTheme1', // myTheme1
			sheet 			: false,
			is_open_modal 	: false,
			num_events 	 	: 0,
			list_local 	 	: [],
			counterDetailsVisible: false,
			counterDetailsSession: null,
			counterDetailsEvents: [],
			counterDetailsLoading: false,
			counterDetailsVideoUrl: null,
			counterDetailsVideoContextTimestamp: null,
			list_devices 	: [],
			info 			: {
				title 			: 'objects',			
				subtitle 		: "",
				color_title 	: "primary",
				color_subtitle 	: "success",	
				class_subtitle  : "mx-2 text-uppercase",
				/*
				devices 				: ['all'],
				names_devices  			: ['all'],
				workstations 			: ['my_computer'],
				names_workstations 		: ['my_computer'],
				smart_events  			: ['all'],
				names_smart_events  	: ['all'],
				*/
			},	
			show_search 	: false,
			dates 			: [],
			ref         	: '',
			list_refs 		: ['alarms', 'lpr', 'actions', 'smart_event', 'reports', 'objects', 'parking', 'avc','counter', 'mixta', 'access_control'],
			event_ref_aliases	: {
				control: 'access_control',
			},
			searcher_tag  	: ['alarms',  'actions', 'smart_event', 'reports', 'objects'],
			searcher_def   	: ['lpr', 'parking', 'avc', 'counter', 'mixta'],			
			list_tags 		: [], // 'person', 'gun', 'face', 'hands up', 'access denied'
			selected_tags 	: [],
			render_tags 	: [],
			search_tag 		: '',		
			list_tables  	: [
				{ name : 'lpr', },
				{ name : 'motion',},
				{ name : 'objects',},
				{ name : 'face',},
				{ name : 'alarms'},
				{ name : 'actions'},
				{ name : 'technical'},
				{ name : 'smart_event'},
				{ name : 'reports'},
				{ name : 'peripherals'},
				{ name : 'incidents'	},
				{ name : 'parking' 		},
				{ name : 'audios' 		},
				{ name : 'face_detected' 	},
				{ name : 'face_recognized' 	},
				{ name : 'avc' 	},
				{ name : 'counter' },
				{ name : 'mixta' },
				{ name : 'access_control' },
			],				
			channel_bus 	: '',
			ID_notification : 'table_events',
			list_channels   : {
				motion 			: 'motion_event',					
				alarms 			: 'events_alerts',					
				lpr 			: 'events_lpr', 
				actions 		: 'events_action',
				alerts 			: 'events',
				objects 		: 'events_object',
				weapon_detector : 'events',
				technical  		: 'events_technical',
				smart_event 	: 'events_smart_event',
				peripherals  	: 'events_peripheral',
				incidents 		: 'events_incidents',
				parking 		: 'events_parking',
				audios 			: 'events_audios',
				face_detected	: 'events_face',
				face_recognized : 'events_face_recognized',
				avc 			: 'events_avc',
				counter			: 'events_counter',
				access_control	: 'access_control'

				
			},
			bus_channels      : {},
			current_bus_table : null,
			list_codes  	: {
				"COM-E400" : ''
			}, 
			toggle : {
				show : false,
				icon : 'mdi-view-sequential',  //  mdi-view-grid
				text : 'view_list', // view_grid
			},
			items_page 		 : 0,
			number_pages  	 : 7, 
			list_local 		 : [],
			item_search   	 : {
				key 		 : 'search',
				text 		 : 'search',
				placeholder  : 'device',
				list 		 : 'list_devices',
				key_list	 : 'deviceId',
				text_list 	 : 'name',
				type 		 : 'field_searcher',
				key_search   : 'name',
				key_search_1 : 'deviceId',
				visible 	 : true,
				cols 		 : {
					col : 2,
				},
			},
			item_dates : {
				key 				: 'dates',
				text 				: 'select_dates',
				placeholder 		: 'select_dates', 
				key_link 			: '',
				icon 				: 'mdi-calendar-multiple',
				is_icon 			: true,
				color 				: '',
				type 				: 'date_range',
				action 				: 'sel_device',	
			},
			info_date 			: {},
			info_device 		: {},
			item_search_device 	: {
				key 		: 'search',
				text 		: 'search',
				placeholder : 'device',
				list 		: 'list_devices',
				key_list	: 'deviceId',
				text_list 	: 'name',
				type 		: 'select_searcher',
				key_search  : 'name',
				key_search_1 : 'deviceId',
				visible 	: true,
				multiple 	: true,
				cols 		: {
					col : 2,
				},
			},
			btn_options 	: [
				{
					key  	: "show_filters",
					text 	: "show_filters",
					action 	: "show_filters",
					icon 	: 'mdi-filter-menu',
					color 	: 'white',
					enable  : true,
				},
				{
					key  	: "hide_filters",
					text 	: "hide_filters",
					action 	: "hide_filters",
					icon 	: 'mdi-filter-minus',
					color 	: 'secondary',
					enable  : false,

				},
				{
					key  	: "redirect_reports",
					text 	: "redirect_reports",
					action 	: "redirect_reports",
					icon 	: 'mdi-arrow-right-top',
					color 	: 'white',
					enable  : false,

				},
				{
					key  	: "pdf",
					text 	: "download_pdf",
					action 	: "download_pdf",
					icon 	: 'mdi-file-pdf-box',
					color 	: 'error',
					enable  : false,

				},
				{
					key  	: "excel",
					text 	: "download_excel",
					action 	: "download_excel",
					icon 	: 'mdi-microsoft-excel',
					color 	: 'success',
					enable  : false,
				},
			],
			show 		: {
				search_tag  	: false,
				search_text 	: false,
				filters  		: false, // _dates
				// search_device 	: false,
				close 			: false,
				title 			: true,
				devices  		: true,
				workstations 	: true,
				smart_events    : false,
			},
			search_cols : {
				xl : 8,
				lg : 8,
				md : 10,
				sm : 10,
				xs : 10,
				cols : 10,
			},
			routes_with_close 			: ["dashboard"],
			total_view_toggle 			: 0,
			info_search 				: {},
			list_searchers 				: [
				{
					key 				: 'start',
					text 				: 'select_time',
					placeholder 		: 'select_start_time', 
					key_link 			: '',
					icon 				: 'mdi-calendar-multiple',
					is_icon 			: true,
					color 				: '',
					type 				: 'time_picker',
					action 				: 'sel_date_start',	
					ref 				: vm.layout_id + "start_time",
				},
				{
					key 				: 'end',
					text 				: 'select_time_ end',
					placeholder 		: 'select_end_time', 
					key_link 			: '',
					icon 				: 'mdi-calendar-multiple',
					is_icon 			: true,
					color 				: '',
					type 				: 'time_picker',
					action 				: 'sel_date_end',	
					ref 				: vm.layout_id + "end_time", 
				}
			],
			list_devices 				: vm.$store.getters['Devices/list_options_simple'],
			list_smart_events  			: vm.$SmartEvent.get(null, "list_smart_event", 'option_all'),
			list_workstations  			: vm.$store.getters['Workspaces/list_options'],
			no_render_default_tags  	: ["objects", "actions"],
			default_toggle_views  		: ['technical', 'peripherals', 'incidents', 'parking', 'audios', 'face_detected', 'face_recognized', 'avc', 'access_control'],
			multiples  					: {
				title 			: "",				
				devices 		: [ 'all'],
				workstations 	: [ 'all'], // my_computer
				smart_events 	: [ 'all'],
			},
			is_loading_init 			: false,
			menu_options  				: [
				{
					key  	: "title",
					key_1   : "title",
					color 	: "primary",					
					icon 	: 'mdi-table-multiple',
					class 	: "mx-2 mr-3",
					tooltip	: vm.$ml.get("table"),
					list 	: "list_tables",
					action  : "set_header",
					option 	: true,
					multiple : false,
					key_text : "name",
					close_on_content: true,
					key_value : "name",
					// is_return_obj : true,					

				},
				{
					key  	: "smart_events",
					key_1   : "names_smart_events",
					color 	: "primary",
					icon 	: 'mdi-gesture-tap-button',
					class 	: "mx-2 ml-3",
					tooltip	: vm.$ml.get("tags"),
					list 	: "list_smart_events",
					action  : "set_smart_event_group",
					option 	: false,
					multiple : true,
					key_text : "name",
					show_in  : ["alarms"],
					close_on_content: false,
					is_return_obj : true,
					key_value : "id",
				},
				{
					key  	: "devices",
					key_1   : "names_devices",
					color 	: "primary",
					icon 	: 'mdi-devices',
					class 	: "mx-2",
					tooltip	: vm.$ml.get("devices"),
					list 	: "list_devices",
					action  : "set_device_group",
					option 	: false,
					multiple : true,
					key_text : "name",
					close_on_content: false,
					is_return_obj : true,
					key_value : "deviceId",
				},
				{
					key  	: "workstations",
					key_1   : "names_workstations",
					color 	: "primary",
					icon 	: 'mdi-monitor',
					class 	: "mx-2 ml-3",
					tooltip	: vm.$ml.get("workstations"),
					list 	: "list_workstations",
					action  : "set_workstations_group",
					option 	: false,
					multiple : true,
					key_text : "name",
					close_on_content: false,
					is_return_obj : true,
					key_value : "manager_id",
				},
			],
			list_slots : 	[
	      		{
	      			slot 		: "is_incident",
	      			key_color	: "color_incident",
	      			color  		: "secondary",
	      		},
	      		{
	      			slot 		: "is_confirmed",
	      			key_color	: "color_confirmed",
	      			color  		: "secondary",
	      		},
	      		{
	      			slot 		: "isignored",
	      			key_color	: "color_ignored",
	      			color  		: "secondary",
	      		},
	      		{
	      			slot 		: "false_positive",
	      			key_color	: "color_fp",
	      			color  		: "secondary",
	      		},
	      		{
	      			slot 		: "type_incident",
	      			key_color	: "color_type_incident",
	      			color  		: "secondary",
	      		},

	      	],
	      	timeMultiplesDevices : null,
			eventosPorId    : {}, // Diccionario para acceso rápido por ID
			tableUpdateKey  : 0, // Key para forzar actualizaciones de la tabla
			relayIoHistoryRefreshTimer : null,
			mixta_bus_handlers : {},
			mixta_filter_all : true,
			mixta_source_selected : [],
			mixta_max_buffer : 200,
			mixta_buffer_options : [50, 100, 200, 500, 1000],
			/** Totales por API (campo count) para paginado del feed mixto */
			mixta_source_counts : {
				lpr         : 0,
				avc         : 0,
				smart_event : 0,
				alarms      : 0,
			},
			// ── Cloud delivery status map ──
			// Key = alertUUID, value = 'sent' | 'pending'
			cloud_status_map : {},
			// ── Technical table UX ──
			tech_filtered_device  : null,
			tech_filtered_status  : null, // 'error' | 'warning' | 'ok' | null
			tech_show_ok          : false, // panel de cámaras: colapsa las OK por defecto (solo se ven problemas)
			tech_group_duplicates : true,
			tech_drawer_open      : false,
			tech_drawer_camera    : null,
			tech_drawer_list      : [],
			tech_drawer_loading   : false,
			tech_drawer_page      : 1,
			tech_drawer_total     : 0,
			// Mapa de estado por cámara — derivado del estado AUTORITATIVO (workspace/state)
			// y de la lista REAL de dispositivos, NO del feed de eventos.
			// Key = deviceId. Value = { deviceId, name, severity, count_err }
			tech_camera_status    : {},
			tech_state_interval   : null,
		}), //data
		

		created(){
			// create formats			
			// set class to variable global
			this.$Format.update_list('ml', this.$ml);
			this.is_loading_init = true;
 			// console.log("´´´´´´´´´´´´´´´´´´´´´´´´´", this.$Format)
			// set table to show
			const initial_ref = this.resolveInitialEventRef();
			if (initial_ref) {
				this.set_header(initial_ref);
			}
			
			this.ID_notification += this.layout_id;

			if (this.layout_id) {
				if (this.info_to_component && this.info_to_component.toggle) {
					this.toggle = this.info_to_component.toggle;
				}
				
				/*let temp = this.$Helper.get_local('list_events_table');
				if (temp) {
					this.list_local = temp;
					let idx = this.list_local.findIndex( x => (x && x.id == this.layout_id ));
					
					if (idx >= 0) {
						if (this.list_local[idx] && this.list_local[idx].toggle) {
							this.toggle = this.list_local[idx].toggle;
						}
					}
				}*/
			}
			if (this.ref === 'mixta') {
				this.toggle.show = true;
				this.toggle.icon = 'mdi-view-sequential';
				this.toggle.text = 'view_list';
			}
			if (this.info_to_component && !this.info_to_component.toggle && this.default_toggle_views.includes(initial_ref)) {
				this.actions('toggle_view');
			}

			if (this.$route && this.$route.name) {
				if (this.routes_with_close.includes(this.$route.name) || this.$route.name.includes("dashboard")) {
					this.show.close = true;
				}
				if (this.$route.name == 'setting_device' || this.$route.name == 'setting_analytic'){  
					this.show.workstations 	= false;
					this.show.device 		= false;
				}else{
					this.show.workstations 	= true;
					this.show.device 		= true;
					if (this.$route.name.includes("dashboard")) {
			    		let modul = this.$store.getters["auth/permission"]("dashboard");
			    		
			    		if (!modul.can_edit) {
			    			this.show.close 		= false;			
							this.show.devices 		= false;
							this.show.workstations  = false;
							this.show.title 		= false;
			    		}
			    	}
				}

			}

			this.render_options_reports();
			this.multiples.devices 		= this.list_devices && this.list_devices.length > 0 ? this.list_devices.map(x => x.deviceId) : ['all'],
			this.multiples.workstations = this.list_workstations && this.list_workstations.length > 0 ? this.list_workstations.map(x => x.manager_id) : ['all']
			this.multiples.smart_events = this.list_smart_events && this.list_smart_events.length > 0 ? this.list_smart_events.map(x => x.id) : ['all'];
			
			// Debug logs para alarms
			if (this.ref_to_component === 'alarms') {
				console.log('🔔 [ALARMS-CREATED] Initialization debug:', {
					list_devices: this.list_devices,
					multiples_devices: this.multiples.devices,
					multiples_smart_events: this.multiples.smart_events,
					ref_to_component: this.ref_to_component
				});
			}
			
			if (this.info_to_component) {
				// this.$nextTick(()=>{
					this.actions("load_component", this.info_to_component);
				// })
			}

			this.$nextTick(() => {
				if (this.relayIoHistoryView) {
					// Vista lista (tabla) por defecto; el toggle arranca en grid en otros flujos
					this.toggle.show = true;
					this.toggle.icon = 'mdi-view-grid';
					this.toggle.text = 'view_grid';
					this.fetchRelayIoStateHistoryList();
				}
			});

		}, // created

		watch:{

			layout : function(v){
				this.onResize();
			}, //layout

			options : {
				handler(){
					if (this.ref === 'mixta') {
						return;
					}
					if (!this.search  && !this.is_reports ) {
						this.get_list();
					}
					// console.log(this.search, 'searching options')
					if (this.search) {
						this.get_search(this.search);
					}
					/*if (this.is_reports) {
						this.$emit('options_report', this.options);

					}*/
				},
				deep: true,
			}, //options

			// El estado del panel técnico ya NO se deriva del feed de eventos (this.list).
			// Eso causaba que las cámaras aparecieran/desaparecieran según qué eventos
			// estuvieran cargados. Ahora el estado viene de tech_load_workspace_state()
			// (estado autoritativo por dispositivo). El feed solo alimenta la tabla/drawer.
			list() {},

			/*search:function(v){
				if (!v) {
					this.loading = true;
				}else{
					// this.get_search(v);
					this.loading = false;
				}
			}, // search*/
			total_report: function(val){
				// console.log(val, 'total_report')
				this.total = val;
			},

			/*report_list:function(val){
				if (val) {
					this.list = val;
				}
			}, // report list*/
			/*multiples : {
				handler(){
					if (!this.is_loading_init) {
						this.actions("update_component");
					}
				}, deep :true
			},*/

		}, // watch

		computed:{
			list_render: function(){
				if (this.ref === 'mixta') {
					let list = (this.list || []).slice().filter(Boolean);
					if (!this.mixta_filter_all && this.mixta_source_selected && this.mixta_source_selected.length) {
						const sel = this.mixta_source_selected;
						list = list.filter((r) => r && sel.indexOf(r.mixta_source_key) >= 0);
					}
					const q = (this.search || '').trim().toLowerCase();
					if (q) {
						list = list.filter((r) => {
							if (!r) return false;
							const hay = [
								r.device,
								r.mixta_identity,
								r.mixta_detalle,
								r.mixta_source,
								r.mixta_action,
								r.date,
								r.mixta_hora
							].filter(Boolean).join(' ').toLowerCase();
							return hay.indexOf(q) >= 0;
						});
					}
					list.sort((a, b) => this.mixtaRowDateMs(b) - this.mixtaRowDateMs(a));
					return list;
				}

				// ── Technical tab: camera filter + deduplication ──
				if (this.ref === 'technical') {
					let tech_list = (this.list || []).slice();
					// Filter by individual camera
					if (this.tech_filtered_device) {
						const name = this.tech_filtered_device.name;
						tech_list = tech_list.filter(r => r && r.device === name);
					} else if (this.tech_filtered_status) {
						// Filter by status group
						tech_list = tech_list.filter(r => r && this.tech_severity(r.tag || '') === this.tech_filtered_status);
					}
					// Deduplicate consecutive same-camera + same-tag rows, show ×N badge via count field
					if (this.tech_group_duplicates) {
						const deduped = [];
						const seen_key = {};
						tech_list.forEach(row => {
							if (!row) return;
							const key = (row.device || '') + '|' + (row.tag || '');
							if (seen_key[key]) {
								seen_key[key]._dup_count = (seen_key[key]._dup_count || 1) + 1;
							} else {
								const clone = { ...row, _dup_count: 1 };
								seen_key[key] = clone;
								deduped.push(clone);
							}
						});
						tech_list = deduped;
					}
					tech_list.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
					return tech_list;
				}

				let list 			= this.list,
					list_new 		= [],
					searching 		= this.search,
					searching_tag 	= this.selected_tags,
					vm 				= this;
				// list_off 		= this.list_off;

				list_new 	= list;
				if (list_new.length > 0) {
						
					// list_new = list.concat(list_off);
					if( this.options.page > 1){
						// list_new = list_off;
					}
				}
				
			
				if (searching) {
					 let list_temp 	= list.filter( function (i) {
					 	return i && i.plate_chars && i.plate_chars.toLowerCase().indexOf(searching.toLowerCase()) > -1
					 })
					 if (list_temp && list_temp.length == 0) {
					 	list_temp 	= list.filter( function (i) {
						 	return i && i.plate && i.plate.toLowerCase().indexOf(searching.toLowerCase()) > -1
						 })
					 }
					 if (list_temp && list_temp.length == 0 && this.ref == "avc") {
					 	list_temp 	= list.filter( function (i) {
						 	return i && i.vehicle_type && i.vehicle_type.toLowerCase().indexOf(searching.toLowerCase()) > -1
						 })
					 }
					 list_new = list_temp;
				
	        		if (list.length === 0) {
						// console.log('search in bd', this.list_search)
						
						  list_new 	= this.list_search;
						// const temp= this.get_search(searching);  
					}
					if (this.list_search && this.list_search.length > 0) {
						list_new 	= this.list_search;
					}
					
        		}else{
        			if (this.total == 0) {
        				this.total = this.last_total;
        			}
        		}	
        		
					 
        		if (searching_tag && searching_tag.length > 0) {
					let list_temp 	= list.filter( function (i) {
					 	return i.tag && searching_tag.includes(i.tag.toLowerCase()) == true;
					 	/*.indexOf(searching.toLowerCase()) > -1*/
					});

					if (list_temp.length === 0){
					 	list_temp = vm.list_search.filter( function (i) {
					 		return i.tag && searching_tag.includes(i.tag.toLowerCase()) == true;
					 	});
					 	list_new = list_temp;
					}
				
	        		if (list_temp.length === 0) {
					 	// console.log(list_temp, "list temp == 0")						
						list_new 	= this.list_search;
						// const temp= this.get_search(searching);  
					}
					if (this.list_search && this.list_search.length > 0) {
						list_new 	= this.list_search;
					}
        		}
        		if (list.length === 0 && this.list_search.length > 0) {					
					list_new 	= this.list_search;	
				}
        		
    			/*if (this.is_reports && this.report_list.length>0) {
    				list_new	= this.report_list;
    				this.total  = this.total_report;
					// console.log('total report in eventss')
    			}*/
				// console.log("LIST ", list_new, this.list_search)
				
				if (list_new && list_new.length > 0) { 						
					this.items_page = list_new.length === 1 ? 1 : list_new.length - 1;		
					if (this.ref == "parking") {
						list_new.sort(function(a,b){
						  // Turn your strings into dates, and then subtract them
						  // to get a value that is either negative, positive, or zero.
						  return    new Date(b.updatedAt) - new Date(a.updatedAt);
						});
					}else{

						list_new.sort(function(a,b){
						  // Turn your strings into dates, and then subtract them
						  // to get a value that is either negative, positive, or zero.
						  return    new Date(b.createdAt) - new Date(a.createdAt);
						});					
					}
					return list_new;
    			}else{
    				return [];
    			}
				
			},


			currentUser() {
		      return this.$store.state.auth.user;
		    },

			relayIoHistoryView() {
				try {
					return this.ref === 'peripherals'
						&& this.$route && this.$route.name === 'setting_device'
						&& this.info_logs
						&& this.info_logs.type_peripheral === 'iot_relay'
						&& !!this.host_from;
				} catch (e) {
					return false;
				}
			},

			eventsPaginationLength() {
				if (this.ref === 'mixta') {
					const ipp = Number(this.options.itemsPerPage) || 15;
					const n = this.mixtaPaginationTotal;
					return Math.max(1, Math.ceil(n / ipp) || 1);
				}
				return this.total_view_toggle || 1;
			},

			/** Suma de `count` por tipo (API), acotada a filtros de origen; con búsqueda/tags usa filas en memoria */
			mixtaPaginationTotal() {
				if (this.ref !== 'mixta') {
					return Number(this.total) || 0;
				}
				const textSearch = this.search && String(this.search).trim();
				const tagSearch = this.selected_tags && this.selected_tags.length;
				if (textSearch || tagSearch) {
					return (this.list_render && this.list_render.length) || 0;
				}
				const c = this.mixta_source_counts || {};
				const keys = ['lpr', 'avc', 'smart_event', 'alarms'];
				if (this.mixta_filter_all) {
					return keys.reduce((s, k) => s + (Number(c[k]) || 0), 0);
				}
				const sel = this.mixta_source_selected || [];
				if (!sel.length) {
					return keys.reduce((s, k) => s + (Number(c[k]) || 0), 0);
				}
				return sel.reduce((s, k) => s + (Number(c[k]) || 0), 0);
			},

			/** Página actual para v-data-table en modo servidor (mixta) */
			mixtaTablePageItems() {
				const lr = this.list_render || [];
				const page = Math.max(1, Number(this.options && this.options.page) || 1);
				const ipp = Number(this.options && this.options.itemsPerPage) || 30;
				const start = (page - 1) * ipp;
				return lr.slice(start, start + ipp);
			},

			// ── Persistent camera status chips — derived from tech_camera_status map, not this.list.
			// This never flickers on API reloads because the map is only ever additive.
			// Con 100+ cámaras solo se pintan las que tienen problema (error/warning/unknown);
			// las OK se colapsan en un chip-resumen expandible => menos DOM y foco en lo crítico.
			camera_chips() {
				if (this.ref !== 'technical') return [];
				const order = { error: 0, warning: 1, ok: 2, unknown: 3 };
				const colorBySeverity = { error: 'error', warning: 'orange', ok: 'success', unknown: 'grey' };
				const showOk = this.tech_show_ok;
				const out = [];
				// Una sola pasada: filtrar OK (salvo expandido) y mapear color/dim.
				Object.values(this.tech_camera_status).forEach(cam => {
					if (!showOk && cam.severity === 'ok') return;
					let chip_color = colorBySeverity[cam.severity] || 'grey';
					const isSelectedCam = this.tech_filtered_device && this.tech_filtered_device.deviceId === cam.deviceId;
					if (isSelectedCam) chip_color = 'primary';
					const dimmed = (this.tech_filtered_status && !this.tech_filtered_device && cam.severity !== this.tech_filtered_status)
						|| (this.tech_filtered_device && !isSelectedCam);
					out.push({ ...cam, chip_color, dimmed });
				});
				out.sort((a, b) => (order[a.severity] ?? 3) - (order[b.severity] ?? 3)
					|| String(a.deviceId || '').localeCompare(String(b.deviceId || '')));
				return out;
			},

			tech_status_counts() {
				if (this.ref !== 'technical') return { error: 0, warning: 0, ok: 0, unknown: 0 };
				const counts = { error: 0, warning: 0, ok: 0, unknown: 0 };
				Object.values(this.tech_camera_status).forEach(cam => {
					counts[cam.severity] = (counts[cam.severity] || 0) + 1;
				});
				return counts;
			},
		}, //computed

		methods: {
			normalizeEventRef(ref) {
				if (!ref) return ref;
				const normalized = String(ref).trim();
				return this.event_ref_aliases[normalized] || normalized;
			},

			isKnownEventRef(ref) {
				return this.list_tables.some(table => table && table.name === ref);
			},

			resolveInitialEventRef() {
				const requestedRef = this.normalizeEventRef(this.ref_to_component);
				const savedTitle = this.info_to_component && this.info_to_component.multiples && this.info_to_component.multiples.title;
				const savedInfo = this.info_to_component && this.info_to_component.info;
				const savedInfoTitle = savedInfo && [savedInfo.title, savedInfo.subtitle].filter(Boolean).join('_');

				const savedCandidates = [savedTitle, savedInfoTitle]
					.map(ref => this.normalizeEventRef(ref));
				const savedRef = savedCandidates.find(ref => ref && this.isKnownEventRef(ref));
				const savedCanOverrideRequestedRef = requestedRef === 'face_detected' && savedRef === 'access_control';

				if (requestedRef && this.isKnownEventRef(requestedRef) && !savedCanOverrideRequestedRef) {
					return requestedRef;
				}

				return savedRef || requestedRef || this.ref_to_component;
			},

			accessControlDeviceName(deviceId) {
				if (!deviceId) return null;
				const devices = this.list_devices || [];
				const found = devices.find(device => device && String(device.deviceId) === String(deviceId));
				return found && (found.name || found.deviceName || found.text || found.label);
			},

			accessControlEvidencePath(item) {
				return item && (item.raw_snap_path || item.snap_path || (item.item && item.item.snap_path));
			},

			accessControlEvidenceUrl(path) {
				if (!path) return path;
				if (/^https?:\/\//i.test(path)) return path;
				const base = this.$URL || '';
				if (!base) return path;
				return `${String(base).replace(/\/$/, '')}/${String(path).replace(/^\//, '')}`;
			},

			formatAccessControlEventInfo(item) {
				const formatted = formatAccessControlEvent(item, key => this.$ml.get(key));
				formatted.device_label = this.accessControlDeviceName(formatted.deviceId) || formatted.device_label;
				return {
					...formatted,
					item,
					formated: {
						analytic: 'access_control',
						deviceId: formatted.deviceId,
						createdAt: item && (item.occurred_at || item.createdAt),
						content: formatted,
					},
				}
			},

			normalizeAvcLiftedAxleCount(value) {
				if (value === null || value === undefined || value === '') return 0;
				return value;
			},

			normalizeEventRow(row, ref, rawItem = null) {
				if (!row || ref !== 'avc') return row;
				const rawValue = row.detected_lifted_axle_count !== undefined
					? row.detected_lifted_axle_count
					: rawItem && rawItem.detected_lifted_axle_count;
				return {
					...row,
					detected_lifted_axle_count: this.normalizeAvcLiftedAxleCount(rawValue),
				};
			},

			formatEventInfo(item, ref) {
				if (ref === 'access_control') {
					return this.formatAccessControlEventInfo(item);
				}
				const info = this.$Format.format_info(item, ref, 'table');
				return this.normalizeEventRow(info, ref, item);
			},

			set_header(head, refresh = false){
				let vm 		= this;
				let find 	= this.list_tables.findIndex(x => (x && x.name == head));
				if (find >= 0) {
						// console.log("Table finded: " , head);
					if (this.$Debug && this.$Debug.logs) {
					}
				}else{
					EventBus.$emit('notifications_modal',{
						type 	: 'warning',
						message : 'This table not exist : ' + head
					});
					head = 'objects';
				}
				
				// Reset technical filters when switching tabs
				if (head !== this.ref) {
					this.tech_filtered_device = null;
					this.tech_filtered_status = null;
					if (head !== 'technical') {
						this.tech_camera_status = {};
					}
				}
				this.ref 		= head;

				// Panel técnico: estado autoritativo por polling (no por el feed de eventos)
				if (head === 'technical') {
					this.tech_start_state_polling();
				} else {
					this.tech_stop_state_polling();
				}
				let sub_head 	= head.split("_");
				
				// console.log("SUB title **************** ", head, sub_head, this.info_to_component)
				if (["alarms", "smart_event"].includes(head)) {
					this.show.smart_events = true;
					if (head.includes("alarms")) {
						this.info.color_title = "error";
						this.list_smart_events = this.$SmartEvent.get(null, "list_smart_event", 'option_all_alert');
					}else{					
						this.info.color_title = "primary";
						this.list_smart_events = this.$SmartEvent.get(null, "list_smart_event", 'option_all_no_alert');
					}
				}else{
					this.info.color_title	= "primary";
					this.show.smart_events 	= false;
				}
				
				this.info 			= {
					...this.info,
					title 	 : sub_head[0] || head,					
					subtitle : sub_head[1]  || ""	
				};
				if (this.multiples) {
					this.multiples.title = head; 
				}
				// console.log("SUB title 1 **************** ", this.info, head)

				if (this.searcher_def.includes(this.ref)) {
					this.show.search_text = true;
				}else{
					this.show.search_text = false;

				}
				if (this.searcher_tag.includes(this.ref)) {
					this.show.search_tag = true;
				}else{
					this.show.search_tag = false;

				}
				
				
				this.render_default_tags();
				if (head === 'mixta') {
					this.list = [];
					this.list_search = [];
					this.eventosPorId = {};
					this.toggle.show = true;
					this.toggle.icon = 'mdi-view-sequential';
					this.toggle.text = 'view_list';
					this.info.title = vm.$ml.get('mixta_feed_title');
					this.info.subtitle = vm.$ml.get('mixta_feed_subtitle');
					this.info.color_title = 'cyan';
					this.headers = [
						{ text: 'device', value: 'mixta_device', align: '' },
						{ text: 'mixta_col_identity', value: 'mixta_identity', align: '' },
						{ text: 'mixta_col_detail', value: 'mixta_detalle', align: '' },
						{ text: 'mixta_col_source', value: 'mixta_source', align: 'center' },
						{ text: 'mixta_col_action', value: 'mixta_action', align: 'center' },
						{ text: 'mixta_col_time', value: 'mixta_hora', align: '' },
					];
				} else if (head == "lpr") {
					this.headers = [
						{ text: 'device', 		value: 'device'},
						{ text: 'plate', 		value: 'plate_chars'},
						{ text: 'segment', 		value: 'img', align: 'center', icon : "mdi-cursor-default-click"},
						{ text: 'speed', 		value: 'speed'},
						{ text: 'speed_limit', 	value: 'speed_limit'},
						{ text: 'direction', 	value: 'direction'},
						{ text: 'attributes', 	value: 'attributes'},
						{ text: 'date', 		value: 'date'},
						{ text: 'cloud', 		value: 'cloud_status', align: 'center', sortable: false },
					]; //headers
				}else

				if (head == "access_control") {
					this.headers = [
						{ text: 'date', value: 'occurred_at', align: '' },
						{ text: 'user', value: 'user_label', align: '' },
						{ text: 'access_method', value: 'method', align: '' },
						{ text: 'access_status', value: 'status', align: '' },
						{ text: 'door_status', value: 'door_status', align: '' },
						{ text: 'reader_id', value: 'reader_id', align: '' },
						{ text: 'device', value: 'device_label', align: '' },
						{ text: 'event_source', value: 'source_label', align: '' },
						{ text: 'evidence', value: 'evidence_label', align: '' },
					];
				}else

				if (head == "alerts") {					
					this.headers = [
						{
							text: 'category', //Catergory
					        align: '',
					        sortable: false,
					        value: 'categorie',//catergory
						},				
						{ text: 'device',  	 value: 'device'},
						{ text: 'plate', 	 value: 'plate_chars'},
						// { text: vm.$ml.get('motive'), value: 'motive',
						{ text: 'evidence', 	 value: 'img', icon : "mdi-cursor-default-click"},
						{ text: 'probability', value : 'probability' },		 
						{ text: 'date',  	 value: 'createdAt'},
					];
				}else if(head == "objects"){
					this.headers = [
						{ text: 'device', 			value: 'device', align: '' },
						{ text: 'tags', 			value: 'tags_colors', 	align: '',},
						{ text: 'speed', 			value: 'speed', 	align: '',},
						{ text: 'evidence', 		value: 'img', align: 'center', icon : "mdi-cursor-default-click"},
						{ text: 'probability', 		value : 'probability' },
				 		{ text: 'date', 			value: 'date', align: '',},
				 		{ text: 'cloud', 			value: 'cloud_status', align: 'center', sortable: false },
				 	];
				}else if (head == "motion") {					
					this.headers = [
						{ text: 'device', 			value: 'device', align: '' },
						{ text: 'tags', 			value: 'tags_colors', 	align: '',},
						{ text: 'evidence', 		value: 'img', align: 'center', icon : "mdi-cursor-default-click"},
						{ text: 'probability', 		value : 'probability' },												
				 		{ text: 'date', 			value: 'date', align: '',},
				 	];

				}else

				if (head == "weapon_detector") {
					this.headers = [
						// { text: vm.$ml.get('id'), 	value: 'id', align: 'center' },
						{ text: 'device', value: 'device', align: '' },
						{ text: 'category', value: 'category', align: '' },
						{ text: 'segment', 	value: 'img', align: '', icon : "mdi-cursor-default-click" },
						{ text: 'date', 	value: 'date', align: '' },

					];
				}else
				if (head == "alarms" || head == "smart_event") {
					this.headers = [
						// { text: vm.$ml.get('id'), 		value : 'id', align: 'center' },
						{ text : 'device', 		value : 'device', align: '' },
						{ text : 'tag', 		value : 'tags_colors', align: '' },
						{ text : 'evidence', 	value : 'img', align: '', icon : "mdi-cursor-default-click" },
						{ text : 'probability', value : 'probability' },
						// { text : 'owner', value : 'owner' },
						// { text : 'detail', value : 'detail' },

						{ text : 'date', 		value : 'date', align: '' },
						{ text : 'side', value : 'side', align: '' },
						{ text : 'way', value : 'way', align: '' },
						{ text : 'type_incident', value : 'type_incident', align: '' },

						// { text : vm.$ml.get('is_incident'), value : 'is_incident', align: '' },
						// { text : vm.$ml.get('confirmed_alert'), value : 'is_confirmed', align: '' },
						{ text : 'user', 			value : 'user', align: '' },
						{ text : 'action', 			value : 'action_done', align: '' },
						{ text : 'confirmed_date', 	value : 'date1', align: '' },
						// { text : vm.$ml.get('isignored'), 			value : 'isignored', align: '' },
						// { text : vm.$ml.get('false_positive'), 	value : 'false_positive', align: '' },
						{ text : 'cloud', value : 'cloud_status', align: 'center', sortable: false },

					];
				}else

				if (head == 'actions') {
					this.headers = [
						// { text: vm.$ml.get('id'), 	value: 'id', align: 'center' },
						{ text: 'device', 	value: 'device', align: '' },
						{ text: 'tags', 	value: 'tags_colors', align: '' },
						{ text: 'evidence', 	value: 'img', align: '', icon : "mdi-cursor-default-click"},
						{ text: 'probability', value : 'probability' },		 
						{ text: 'date', 	value: 'date', align: '' },

					];	
				}else

				if (head == 'technical') {
					this.headers = [
					{ text : "state", value : "img_tech", align : 'center' },
					{ text : "device", value : "device" },
					{ text : "computer", value : "computer" },
					{ text : "detail", value : "tag" },
					// { text : vm.$ml.get("code"), value : "code" },
					// { text : vm.$ml.get("module"), value : "module" },
					// { text : vm.$ml.get("type"), value : "type" },
					{ text : "date", value : "date" },				
					];
				}else
				if (head == 'reports') {
					this.headers = [
					// { text : vm.$ml.get("state"), value : "img_tech", align : 'center' },
					{ text : "device", value : "device" },
					{ text: 'tags', 	value: 'tags_colors', align: '' },
					// { text : vm.$ml.get("computer"), value : "computer" },
					// { text : vm.$ml.get("detail"), value : "tag" },
					// { text : vm.$ml.get("code"), value : "code" },
					// { text : vm.$ml.get("module"), value : "module" },
					// { text : vm.$ml.get("type"), value : "type" },
					{ text : "date", value : "date" },				
					];
				}
				else
				if (head == "peripherals") {
					if (this.$route.name === 'setting_device' && this.info_logs && this.info_logs.type_peripheral === 'iot_relay') {
						this.headers = [
							{ text: 'date', value: 'date', align: '' },
							{ text: 'io_kind', value: 'ioKind', align: 'center' },
							{ text: 'pin', value: 'ioIndex', align: 'center' },
							{ text: 'previous', value: 'previousState', align: 'center' },
							{ text: 'new_state', value: 'newState', align: 'center' },
							{ text: 'mqtt_topic', value: 'mqttTopic', align: '' },
						];
					} else {
						this.headers = [
							{ text : "name", value : "name" },
							{ text : 'type_peripheral', 	value: 'tags_colors', align: '' },
							{ text : "detail", value : "detail" },
							{ text : "date", value : "date" },
						];
					}
				}else
				if (head == "incidents") {
					this.headers = [
						{ text : "name", value : "name" },
						{ text : "device", value : "device" },
						// { text : vm.$ml.get('type'), 	value: 'type', align: '' },										
						{ text : "state", value : "state" },				
						{ text : "date", value : "date" },		
					];
				}else
				if (head == "parking") {
					this.headers = [
						{ text : "information", value : "information" },
						{ text : "entry", value : "entry" },
						{ text : 'exit', 	value: 'exit', align: '' },										
						{ text : "status", value : "status" },				
						{ text : "invoice", value : "invoice" },	

					];
				}else
				if (head == "audios") {
					this.headers = [
						{ text : "name", value : "name" },
						{ text : "device", value : "device" },
						{ text : 'audio', 	value: 'audio', align: '' },										
						{ text : "duration", value : "duration" },				
						{ text : "date", value : "date" },	

					];
				}else
				if (head.includes("face")) {
					this.headers = [
						{ text: 'device', 			value: 'device', align: '' },
						{ text: 'tags', 			value: 'tags_colors', 	align: '',},
						{ text: 'evidence', 		value: 'img', align: 'center', icon : "mdi-cursor-default-click"},
						{ text: 'probability', 		value: 'probability' },												
				 		{ text: 'date', 			value: 'date', align: '',},
				 	];

				}else
				if (head == "avc") {
					this.headers = [
						{ text: 'device', 			value: 'device', align: '' },
						{ text: 'vehicle_type', 	value: 'tags_colors', 	align: '',},
						{ text: 'axle_counter', 	value: 'axle_counter' },
						{ text: 'lifted_axles', 	value: 'detected_lifted_axle_count' },
						{ text: 'evidence', 		value: 'img', align: 'center', icon : "mdi-cursor-default-click"},
				 		{ text: 'date', 			value: 'date', align: '',},
				 		{ text: 'cloud', 			value: 'cloud_status', align: 'center', sortable: false },
				 	];
				}else 
				if(head=="counter"){
					this.headers = [
						{ text: 'Detalles', value: 'details', align: 'center' },
						{ text: 'Barcode', value: 'barcode' },
						{ text: 'Device', value: 'device_name' },
						{ text: 'Inicio', value: 'inicio' },
						// { text: 'Foto inicio', value: 'full_photo_url_start' }, // Ocultada temporalmente
						{ text: 'Fin', value: 'fin' },
						// { text: 'Foto fin', value: 'full_photo_url_end' }, // Ocultada temporalmente
						{ text: 'Duration', value: 'duration' }, // nuevo campo
						{ text: 'Totalizers', value: 'totalizers' }, // nuevo campo
						{ text: 'State', value: 'state_icon' },
						{ text: 'PDF', value: 'pdf', align: 'center' },
						{ text: 'Video Evidence', value: 'video_evidence', align: 'center' }
					];
				}


				this.get_status(head);
				this.set_bus_table(head);

				if (head === 'mixta') {
					this.fetchMixtaListFromApis();
				} else if (refresh) {
					this.get_list();
				}
			}, //set header
			addOrUpdateData(newData) {
				// Si el evento ya existe, actualiza; si no, agrega al inicio
				if (newData.item && newData.item.tracker_id) {
					const id = newData.item.tracker_id;
					if (!this.eventosPorId[id]) {
						// Nuevo evento
						this.list.unshift(newData);
						this.mark_cloud_pending(newData);
						this.eventosPorId[id] = newData;
						// Limitar tamaño de la lista
						if (this.list.length > 50) {
							const eliminado = this.list.pop();
							if (eliminado && eliminado.item && eliminado.item.tracker_id) {
								delete this.eventosPorId[eliminado.item.tracker_id];
							}
						}
					} else {
						// Si ya existe, actualiza el objeto
						const idx = this.list.findIndex(item => item.item.tracker_id == id);
						if (idx !== -1) {
							// Actualiza la referencia en la lista y el diccionario
							this.list[idx] = { ...this.list[idx], ...newData };
							this.eventosPorId[id] = this.list[idx];
						}
					}
				}
			},//addOrUpdateData

			/** Timestamp para ordenar mixta: primero `date` (texto), si no sirve `createdAt` */
			mixtaRowDateMs(row) {
				if (!row) return 0;
				const vm = this;
				const s = row.date != null && String(row.date).trim() ? String(row.date).trim() : '';
				if (s && !/^(AM|PM)$/i.test(s)) {
					const m1 = vm.moment(s, [
						'YYYY-MM-DDTHH:mm:ss.SSSZ',
						'YYYY-MM-DDTHH:mm:ssZ',
						'MM/DD/YYYY hh:mm:ss A',
						'MM/DD/YYYY HH:mm:ss',
						'DD/MM/YYYY HH:mm:ss',
						'YYYY-MM-DD HH:mm:ss',
						'YYYY-MM-DD hh:mm:ss A',
					], true);
					if (m1.isValid()) return m1.valueOf();
					const mLoose = vm.moment(s);
					if (mLoose.isValid()) return mLoose.valueOf();
				}
				const ca = row.createdAt;
				if (ca == null || ca === '') return 0;
				const t = typeof ca === 'number' ? ca : new Date(ca).getTime();
				return Number.isFinite(t) ? t : 0;
			},

			mixtaSortListByDateDesc(list) {
				if (!list || !list.length) return;
				const vm = this;
				list.sort((a, b) => vm.mixtaRowDateMs(b) - vm.mixtaRowDateMs(a));
			},

			formatExecutedActionsForMixta(item) {
				const vm = this;
				const source = item || {};
				const records = Array.isArray(source.action_execution_records) ? source.action_execution_records : [];
				const executed = Array.isArray(source.executed_actions) ? source.executed_actions : [];
				const labels = records.length
					? records.map((record) => {
						if (!record) return '';
						if (record.label) return record.label;
						if (record.device_name && record.action) return `${record.device_name}: ${record.action}`;
						return record.action || record.description || '';
					})
					: executed.map((record) => {
						if (!record) return '';
						if (typeof record === 'string') return record;
						return record.label || record.action || record.description || '';
					});

				const cleaned = labels.map(label => String(label || '').trim()).filter(Boolean);
				return cleaned.length ? cleaned.join(', ') : vm.$ml.get('mixta_no_executed_actions');
			},

			buildMixtaRow(newFormat, sourceKey, rawMessage) {
				const vm = this;
				let createdAt = null;
				let mixta_hora = '';
				const fmt = vm.$Format;
				const canonicalMs = fmt && typeof fmt.itemTimestampToMs === 'function'
					? fmt.itemTimestampToMs(rawMessage)
					: null;
				try {
					if (canonicalMs != null && Number.isFinite(canonicalMs)) {
						createdAt = canonicalMs;
						mixta_hora = vm.moment(canonicalMs).format('YYYY-MM-DD HH:mm:ss');
					} else {
						createdAt = rawMessage && rawMessage.createdAt
							? rawMessage.createdAt
							: (newFormat.formated && newFormat.formated.createdAt)
								? newFormat.formated.createdAt
								: null;
						if (typeof createdAt === 'number' && isFinite(createdAt) && createdAt > 0 && createdAt < 1e12) {
							createdAt = createdAt * 1000;
						} else if (typeof createdAt === 'string' && /^\d{9,12}$/.test(createdAt.trim())) {
							const n = Number(createdAt);
							if (n > 0 && n < 1e12) createdAt = n * 1000;
						}
						if (createdAt != null && createdAt !== '') {
							const m0 = vm.moment(createdAt);
							if (m0.isValid()) {
								mixta_hora = m0.format('YYYY-MM-DD HH:mm:ss');
								createdAt = m0.valueOf();
							}
						}
						if (!mixta_hora && newFormat.date) {
							const s = String(newFormat.date).trim();
							if (s && !/^(AM|PM)$/i.test(s)) {
								const m1 = vm.moment(s, [
									'YYYY-MM-DDTHH:mm:ss.SSSZ',
									'YYYY-MM-DDTHH:mm:ssZ',
									'MM/DD/YYYY hh:mm:ss A',
									'MM/DD/YYYY HH:mm:ss',
									'DD/MM/YYYY HH:mm:ss',
									'YYYY-MM-DD HH:mm:ss',
									'YYYY-MM-DD hh:mm:ss A',
								], true);
								if (m1.isValid()) {
									mixta_hora = m1.format('YYYY-MM-DD HH:mm:ss');
									if (createdAt == null || createdAt === '' || !vm.moment(createdAt).isValid()) {
										createdAt = m1.valueOf();
									}
								} else {
									const mLoose = vm.moment(s);
									const yLoose = mLoose.isValid() ? mLoose.year() : 0;
									if (mLoose.isValid() && yLoose >= 1980 && yLoose <= 2110) {
										mixta_hora = mLoose.format('YYYY-MM-DD HH:mm:ss');
										if (createdAt == null || createdAt === '' || !vm.moment(createdAt).isValid()) {
											createdAt = mLoose.valueOf();
										}
									} else {
										mixta_hora = s;
									}
								}
							}
						}
						if (createdAt == null || createdAt === '' || !vm.moment(createdAt).isValid()) {
							createdAt = Date.now();
						}
						if (!mixta_hora) {
							const mf = vm.moment(createdAt);
							mixta_hora = mf.isValid() ? mf.format('YYYY-MM-DD HH:mm:ss') : '';
						}
					}
				} catch (e) {
					createdAt = Date.now();
					mixta_hora = vm.moment(createdAt).format('YYYY-MM-DD HH:mm:ss');
				}
				const baseId = newFormat.id != null ? String(newFormat.id) : `${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
				const id = `mixta_${sourceKey}_${baseId}`;
				const row = {
					id,
					createdAt,
					mixta_source_key: sourceKey,
					formated: newFormat.formated,
					mixta_modal_analytic: sourceKey,
					device: newFormat.device || '—',
					mixta_device: newFormat.device || '—',
					mixta_identity: '—',
					mixta_detalle: '',
					mixta_source: '',
					mixta_action: '—',
					date: mixta_hora || newFormat.date || '',
					mixta_hora: mixta_hora || newFormat.date || '',
				};
				if (sourceKey === 'lpr') {
					row.mixta_identity = newFormat.plate_chars || '—';
					const parts = [];
					if (newFormat.speed != null && newFormat.speed !== '') {
						parts.push(`${vm.$ml.get('speed')}: ${newFormat.speed}`);
					}
					if (newFormat.speed_limit != null && newFormat.speed_limit !== '') {
						parts.push(`${vm.$ml.get('speed_limit')}: ${newFormat.speed_limit}`);
					}
					if (newFormat.direction != null && newFormat.direction !== '') {
						parts.push(`${vm.$ml.get('direction')}: ${newFormat.direction}`);
					}
					if (newFormat.attributes && newFormat.attributes.length) {
						const attrParts = newFormat.attributes.map((a) => (a && (a.value || a.classname)) || '').filter(Boolean);
						if (attrParts.length) {
							parts.push(`${vm.$ml.get('attributes')}: ${attrParts.join(', ')}`);
						}
					}
					row.mixta_detalle = parts.join(' · ');
					row.mixta_source = vm.$ml.get('mixta_source_lpr');
					row.mixta_action = vm.$ml.get('mixta_action_lpr');
				} else if (sourceKey === 'avc') {
					row.mixta_identity = newFormat.vehicle_type || '—';
					const ax = newFormat.axle_counter != null ? newFormat.axle_counter : '—';
					row.mixta_detalle = `${row.mixta_identity}: ${ax}`;
					row.mixta_source = vm.$ml.get('mixta_source_avc');
					row.mixta_action = vm.$ml.get('mixta_action_avc');
				} else if (sourceKey === 'smart_event' || sourceKey === 'alarms') {
					const tags = (newFormat.tags_colors || []).map((t) => t && t.tag).filter(Boolean);
					row.mixta_identity = tags.length ? tags.join(', ') : (newFormat.tag || '—');
					const itemRaw = newFormat.item || rawMessage;
					const motive = itemRaw && itemRaw.motive_categorie ? itemRaw.motive_categorie : '';
					const parts = [];
					if (tags.length) parts.push(tags.join(', '));
					if (motive) parts.push(motive);
					const prob = newFormat.probability;
					if (prob != null && prob !== '') {
						parts.push(`${vm.$ml.get('probability')}: ${prob}`);
					}
					if (newFormat.way != null && newFormat.way !== '') {
						parts.push(`${vm.$ml.get('way')}: ${newFormat.way}`);
					}
					row.mixta_detalle = parts.filter(Boolean).join(' - ');
					row.mixta_source = sourceKey === 'alarms' ? vm.$ml.get('mixta_source_alarms') : vm.$ml.get('mixta_source_smart');
					row.mixta_action = vm.formatExecutedActionsForMixta(itemRaw || newFormat.item || newFormat);
				}
				return row;
			},

			mixtaSelectAll() {
				this.mixta_filter_all = true;
				this.mixta_source_selected = [];
			},

			mixtaToggleSource(key) {
				if (this.mixta_filter_all) {
					this.mixta_filter_all = false;
					this.mixta_source_selected = [key];
					return;
				}
				const idx = this.mixta_source_selected.indexOf(key);
				if (idx >= 0) {
					this.mixta_source_selected.splice(idx, 1);
					if (this.mixta_source_selected.length === 0) {
						this.mixta_filter_all = true;
					}
				} else {
					this.mixta_source_selected.push(key);
				}
			},

			mixtaIdentityIcon(item) {
				if (!item || !item.mixta_source_key) return 'mdi-help-circle-outline';
				const map = {
					lpr: 'mdi-car',
					avc: 'mdi-truck-check',
					smart_event: 'mdi-brain',
					alarms: 'mdi-alert',
				};
				return map[item.mixta_source_key] || 'mdi-circle-small';
			},

			mixtaIdentityIconColor(item) {
				if (!item || !item.mixta_source_key) return '';
				if (item.mixta_source_key === 'alarms') return 'error';
				if (item.mixta_source_key === 'lpr') return 'cyan';
				if (item.mixta_source_key === 'avc') return 'blue';
				return 'primary';
			},

			// for change table
			set_bus_table(head){
				let ev = this;
				if (this.mixta_bus_handlers && Object.keys(this.mixta_bus_handlers).length) {
					Object.keys(this.mixta_bus_handlers).forEach((name) => {
						EventBus.$off(name, this.mixta_bus_handlers[name]);
					});
					this.mixta_bus_handlers = {};
				}
				if (this.current_bus_table === 'mixta_multi') {
					this.current_bus_table = null;
				} else if (this.current_bus_table) {
					EventBus.$off(this.current_bus_table, this.bus_channels[this.current_bus_table]);
				}

				if (head === 'mixta') {
					const pairs = [
						['lpr', 'events_lpr'],
						['avc', 'events_avc'],
						['smart_event', 'events_smart_event'],
						['alarms', 'events_alerts'],
					];
					this.current_bus_table = 'mixta_multi';
					pairs.forEach(([srcKey, evName]) => {
						const handler = (message) => {
							if (ev.ref !== 'mixta') return;
							if (!message || !ev.render_hostname(message)) return;
							// Some emitters send a pre-formatted "table" (with top-level device,
							// formated, item, …); others send the raw WS message. Re-running format_info
							// over an already formatted table can lose data that only existed in the
							// original WS payload (for example LPR device/host name), so preserve it.
							const isFormattedTable = message && typeof message === 'object' && message.formated;
							const rawMsg = (message && typeof message === 'object' && message.item)
								? message.item
								: message;
							const new_format = isFormattedTable ? ev.normalizeEventRow(message, srcKey, rawMsg) : ev.formatEventInfo(rawMsg, srcKey);
							if (!new_format || !new_format.formated) return;
							const row = ev.buildMixtaRow(new_format, srcKey, rawMsg);
							if (!row || !row.id) return;
							const id = row.id;
							const existing = ev.eventosPorId[id];
							if (existing) {
								const merged = { ...existing, ...row };
								ev.eventosPorId[id] = merged;
								const idx = ev.list.findIndex((x) => x && x.id === id);
								if (idx >= 0) ev.list.splice(idx, 1, merged);
								return;
							}
							ev.list.unshift(row);
							ev.mark_cloud_pending(row);
							ev.eventosPorId[id] = row;
							ev.num_events++;
							ev.mixtaSortListByDateDesc(ev.list);
							const maxB = Math.max(10, parseInt(ev.mixta_max_buffer, 10) || 200);
							while (ev.list.length > maxB) {
								const removed = ev.list.pop();
								if (removed && removed.id) delete ev.eventosPorId[removed.id];
							}
							if (ev.$el && ev.$el.offsetParent !== null && new_format.formated && new_format.formated.content && new_format.formated.content.bbox) {
								ev.actions('draw_bbox', { ...new_format.formated });
							}
						};
						this.mixta_bus_handlers[evName] = handler;
						EventBus.$on(evName, handler);
					});
					return;
				}

				let key_channel = head;
				let event_name = this.list_channels && this.list_channels[key_channel] ? this.list_channels[key_channel] : null;
				
				if (event_name) {
					this.current_bus_table = event_name;
					EventBus.$on(event_name, ev.bus_channels[event_name] = (message)=>{
						if (this.ref === 'alarms') {
							console.log('🚨 [ALARMS-EVENT-BUS] Received message for channel:', event_name, 'head:', head, 'message:', message);
						}
						
						if (this.ref === 'counter') {
							console.log('🔔 [EVENT-BUS] Received message for channel:', event_name, 'head:', head, 'message:', message);
						}
						
						if (message && ev.render_hostname(message)) {
							// Manejo especial para eventos counter
							if (head === 'counter') {
								console.log('📊 [COUNTER-EVENT] Processing counter event - message:', message);
								
								// Formatear el mensaje para counter
								const new_format = ev.$Format.format_info(message, head, 'table');
								console.log('📊 [COUNTER-EVENT] Formatted data:', new_format);
								
								// Log específico para totalizers
								if (new_format && new_format.totalizers) {
									console.log('📊 [COUNTER-EVENT] Totalizers found:', new_format.totalizers);
								}
								
								if (new_format) {
									// Crear un ID único para counter events
									// Usar el ID del operationsession si existe, sino crear uno único
									let id = new_format.id;
									let barcode = new_format.barcode;
									
									// Para counter events, usar barcode como identificador principal
									if (barcode) {
										// Si ya existe un evento con este barcode, actualizar en lugar de duplicar
										const existingIndex = ev.list.findIndex(item => item && item.barcode === barcode);
										if (existingIndex >= 0) {
											console.log('📊 [COUNTER-EVENT] Event with barcode already exists, updating:', barcode);
											// Actualizar el evento existente sin $forceUpdate (evita loops con options.sync)
											const updated = { ...ev.list[existingIndex], ...new_format };
											ev.list.splice(existingIndex, 1, updated);
											return; // No agregar duplicado
										}
									}
									
									if (!id && barcode) {
										// Si no hay ID pero hay barcode, crear un ID único
										id = `counter_${barcode}_${Date.now()}`;
									} else if (!id) {
										// Si no hay ni ID ni barcode, crear un ID completamente único
										id = `counter_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
									}
									
									// Asignar el ID al objeto para que la tabla lo use
									new_format.id = id;
									
									// Asegurar que también tenga barcode para counter events
									if (!new_format.barcode) {
										new_format.barcode = id;
									}
									
									console.log('📊 [COUNTER-EVENT] Using unique ID:', id, 'barcode:', new_format.barcode);
									
									// Verificar que no exista ya en la lista
									const existingById = ev.list.find(item => item.id === id);
									const existingByBarcode = ev.list.find(item => item.barcode === new_format.barcode);
									
									if (!existingById && !existingByBarcode) {
										console.log('📊 [COUNTER-EVENT] New event - adding to list with ID:', id);
										ev.list.unshift(new_format);
										ev.eventosPorId[id] = new_format;
										if (ev.list.length > 50) {
											const eliminado = ev.list.pop();
											if (eliminado && eliminado.id) {
												delete ev.eventosPorId[eliminado.id];
											}
										}
										ev.num_events++;
										console.log('📊 [COUNTER-EVENT] Event added - num_events:', ev.num_events, 'total:', ev.total, 'list length:', ev.list.length);
									} else {
										console.log('📊 [COUNTER-EVENT] Event already exists - skipping duplicate. ID:', id, 'barcode:', new_format.barcode);
									}
								} else {
									console.warn('📊 [COUNTER-EVENT] Failed to format event data');
								}
							} else {
								// Manejo normal para otros tipos de eventos
								if (this.ref === 'alarms') {
									console.log('🚨 [ALARMS-EVENT] Processing alarms event - message:', message);
								}
								
								if (this.ref === 'counter') {
									console.log('🔔 [EVENT-BUS] Processing regular event for:', head);
								}
								
								const new_format = message && message.formated ? ev.normalizeEventRow(message, head, message.item || message) : ev.formatEventInfo(message, head);
								
								if (new_format) {
									// Usar el diccionario para evitar findIndex y duplicados
									let id = new_format.item && new_format.item.tracker_id ? new_format.item.tracker_id : new_format.id;
									
									// Para eventos de alarms, crear un ID único si no existe
									if (!id && head === 'alarms') {
										// Crear un ID único basado en el contenido del evento
										const timestamp = new_format.date || new_format.createdAt || Date.now();
										const device = new_format.device || new_format.deviceId || 'unknown';
										const plate = new_format.plate_chars || 'unknown';
										id = `alarms_${device}_${plate}_${timestamp}`;
										
										// Asignar el ID al objeto
										new_format.id = id;
										
										if (this.ref === 'alarms') {
											console.log('🚨 [ALARMS-EVENT] Generated unique ID for alarms event:', id);
										}
									}
									
									if (id) {
										// Verificar que no exista ya en la lista
										const existingEvent = ev.list.find(item => item.id === id);
										
										if (!existingEvent && !ev.eventosPorId[id]) {
											if (this.ref === 'alarms') {
												console.log('🚨 [ALARMS-EVENT] Adding new alarms event to list with ID:', id);
											}
											
											ev.list.unshift(new_format);
											ev.mark_cloud_pending(new_format);
											ev.eventosPorId[id] = new_format;
											if (ev.list.length > 50) {
												const eliminado = ev.list.pop();
												if (eliminado && eliminado.item && eliminado.item.tracker_id) {
													delete ev.eventosPorId[eliminado.item.tracker_id];
												}
											}
											ev.num_events++;
											// Don't increment total for technical tab — it's a live sliding window.
											// Incrementing total changes server-items-length → Vuetify re-emits
											// options → options watcher calls get_list() → this.list = [] (flash).
											if (ev.ref !== 'technical') ev.total++;

											// Solo dibujar bbox si el usuario está viendo la lista (por ejemplo, si el componente está visible)
											if (ev.$el && ev.$el.offsetParent !== null && new_format.formated && new_format.formated.content && new_format.formated.content.bbox) {
												ev.actions("draw_bbox", { ...new_format.formated });
											}
											// Log counter update for counter component
											if (ev.ref === 'counter') {
												console.log('📊 [COUNTER-EVENT] New event received - num_events:', ev.num_events, 'total:', ev.total);
											}
											
											if (this.ref === 'alarms') {
												console.log('🚨 [ALARMS-EVENT] Event added successfully - num_events:', ev.num_events, 'total:', ev.total, 'list length:', ev.list.length);
											}
										} else if (existingEvent) {
											// Si ya existe, actualiza el objeto solo si hay cambios relevantes
											const actual = ev.eventosPorId[id];
											if (JSON.stringify(actual) !== JSON.stringify(new_format)) {
												ev.eventosPorId[id] = { ...actual, ...new_format };
												const idx = ev.list.findIndex(item => (item.item && item.item.tracker_id === id));
												if (idx !== -1) {
													ev.list[idx] = ev.eventosPorId[id];
												}
											}
										}
									}
								}
							}
						} else {
							if (this.ref === 'alarms') {
								console.log('🚨 [ALARMS-EVENT-BUS] Message filtered out or invalid - message:', message, 'render_hostname result:', message ? ev.render_hostname(message) : false);
							}
							
							if (this.ref === 'counter') {
								console.log('🔔 [EVENT-BUS] Message filtered out or invalid - message:', message, 'render_hostname result:', message ? ev.render_hostname(message) : false);
							}
						}
					});
				}else{
					console.warn("No found channel for table ", head)
				}
			}, // set bus table

			actions(act, item, opt){
				// console.log("actions table events : ", act, item, opt)

				if ( act == 'show_search') {
					this.show_search = !this.show_search;
					this.onResize();
				}else
				if ( act == 'toggle_view') {
					if (this.ref === 'mixta') {
						return;
					}
					if (this.toggle.show){
						this.toggle.show = false;
						this.toggle.icon = 'mdi-view-sequential'
						this.toggle.text = 'view_list';
					}else{
						this.toggle.show = true;
						this.toggle.icon = 'mdi-view-grid'
						this.toggle.text = 'view_grid';
					}

					this.actions("update_component");
					
						
						// console.log("actions toggle emit ")
						/*if (this.list_local && this.list_local.length > 0) {
							let idx = this.list_local.findIndex( x => (x && x.id == this.layout_id ));
							if (idx >= 0) {
								this.list_local[idx] = {
									id 		: this.layout_id,
									toggle  : { ...this.toggle },									
								};
							}else{
								this.list_local.push({
									id 		: this.layout_id,									
									toggle  : { ...this.toggle },
								})
							}
						}else{
							this.list_local.push({
								id 		: this.layout_id,									
								toggle  : { ...this.toggle },
							})
						}*/
						// this.$Helper.set_local('list_events_table', [...this.list_local]);
					
				}else
				if ( act == 'close_component') {
					if (this.list_local && this.list_local.length > 0) {
						let idx = this.list_local.findIndex( x => (x && x.id == this.layout_id ));
						// console.log("list_local ", idx)
						if (idx >= 0) {
							this.list_local.splice(idx, 1);
							this.$Helper.set_local('list_events_table', [...this.list_local]);
						}
					}
					this.$nextTick(()=>{
						// console.log('close event ')
						this.$emit('close_component', this.layout_id);
					})
				}else
				if (act == "show_filters") {
					this.render_options_reports(act);
					this.search_cols = {
						xl : 3,
						lg : 3,
						md : 6,
						sm : 6,
						xs : 12,
						cols : 12,
						
					}
					this.onResize();

				}else
				if (act == "hide_filters") {
					this.render_options_reports(act);
					this.search_cols = {
						xl : 8,
						lg : 8,
						md : 10,
						sm : 10,
						xs : 10,
						cols : 10,
					};
					this.onResize();


				}else
				if (act == "redirect_reports") {
					this.$router.push("reports")

				}else
				if (act == "download_excel") {

				}else
				if (act == "check_tags") {
					console.log("CHECK LPR : ", this.selected_tags.some(x => x == 'lpr'))
					if (this.selected_tags.some(x => (x  == 'lpr'))){
						if (['reports', 'smart_event', 'alarms'].includes(this.ref)) {
							this.show.search_text = true;						
						}
					}else{
						this.show.search_text = false;
					}
				}else
				if (act == "play_sound") {					
					this.$Sounds.play_new_sound(item.audio);
				}else
				if (act == "draw_bbox") {
					// console.log("Ready to draw ")
					// item_grid.id + layout_id + ref + 'draw'
					if (item && item.content && item.content.images && item.content.images.length > 0) {
						let items = item.content.images;						
						this.$nextTick(()=>{

							// image background
					        let img               = document.getElementById(item.ID + this.layout_id + this.ref + 'img');

					        // canvas draw
					       	let roi  			  = document.getElementById(item.ID + this.layout_id + this.ref + 'draw');
					        if (roi && roi.getContext('2d')) {
					        	let context_roi       = roi.getContext('2d');
					        	let current_width  = roi.width    = img.getBoundingClientRect().width,  
							        current_height = roi.height   = img.getBoundingClientRect().height;

							    let arr_bbx = items[0];
								if (arr_bbx && typeof arr_bbx == 'string') {
					            	try{
					            		arr_bbx = JSON.parse(arr_bbx)
					            		if (arr_bbx && typeof arr_bbx == 'string') {
					            			arr_bbx = JSON.parse(arr_bbx);
					            		}
					            	}catch(er){
					            		console.log("Not possible convert bbox to object ", er);
					            	}
					            }
							    if (arr_bbx && arr_bbx.bbox && arr_bbx.bbox.length > 0) {
									// console.log("DRAW ROI EVENT ");
									arr_bbx.bbox.forEach( element => {

							       		if (element) {
							            	let temp_tag  			= element.tag || "";
							       			context_roi.strokeStyle = this.set_color_draw();
							       			context_roi.lineWidth   = 2;
								       		let b_box = {
							                	x : element.bbox && element.bbox.x ? element.bbox.x : element.x,
												y : element.bbox && element.bbox.y ? element.bbox.y : element.y,
												w : element.bbox && element.bbox.w ? element.bbox.w : element.w,
												h : element.bbox && element.bbox.h ? element.bbox.h : element.h,
											};
											let fx = b_box.x *  parseInt(current_width) ;
							                let fy = b_box.y *  parseInt(current_height);
							                let w  = b_box.w *  parseInt(current_width);
							                let h  = b_box.h *  parseInt(current_height);

							                fx = Math.abs(fx)
	        								fy = Math.abs(fy)

										    context_roi.strokeRect(fx, fy, w, h); // fill

										    context_roi.font      = "10px Georgia";
											context_roi.fillStyle = "white";
											context_roi.fillText(temp_tag, fx + 20, fy + 10);
								       	}

							       	})
							    }
					        }
						})
					}
				}else
				if (act == "set_header") {
					if (item && item.name) {
						this.set_header(item.name, opt);
						this.$nextTick(()=>{
							this.actions("update_component");							
						});
					}
				}else
				if (act == "set_device_group") {
					// console.log("Set device group ");
					if (item && item.deviceId) {	

						this.$nextTick(()=>{
							// console.log("Set device group item ", item);
							if (this.multiples && this.multiples.devices && this.multiples.devices.length > 0) { 
								if (item.deviceId == 'all') {
									if (this.multiples.devices.includes(item.deviceId)) {
										this.multiples= {
											...this.multiples,
											devices 		: this.list_devices.map(x => x.deviceId),
											workstations 	: this.list_workstations.map(x => x.manager_id)
										};	
									}else{
										this.multiples = {
											...this.multiples,
											devices 		: [],
											workstations 	: [],
										};
									}
								}else if (item.deviceId) {
									if (this.multiples.devices.includes("all")) {
										this.multiples.devices.splice(this.multiples.devices.indexOf('all'),1) 
									}
									const dev = {...item};
									if (dev) {
										let temp_devices =  this.list_devices.filter(x =>{
											if (x.manager_id == dev.manager_id && this.multiples.devices.includes(x.deviceId)) {
												return true;
											}else if (!x.manager_id && !dev.manager_id && this.multiples.devices.includes(x.deviceId)) {
												return true;												
											}
											
										}).map(z => z.deviceId);
										if (!this.multiples.devices.includes(item.deviceId)) {
											// temp_devices.filter(z => this.multiples.devices.incl)
											if (temp_devices && temp_devices.length === 0 && this.multiples && this.multiples.workstations && this.multiples.workstations.length > 0) {
												if (!dev.manager_id) {
												// console.log("CHECK clear ", temp_devices,dev.manager_id,  this.multiples.workstations.indexOf("my_computer"));
													this.multiples.workstations.splice(this.multiples.workstations.indexOf("my_computer"));
												}else{
													this.multiples.workstations.splice(this.multiples.workstations.indexOf(dev.manager_id), 1);
												}
												if (this.multiples.workstations.includes("all")) {
													this.multiples.workstations.splice(this.multiples.workstations.indexOf('all'),1);
												}
											}else if(!this.multiples.workstations.includes(dev.manager_id)){
												// console.log("ADD to workstations")
												if (!dev.manager_id) {
													this.multiples.workstations.push("my_computer");
												}else{
													this.multiples.workstations.push(dev.manager_id);
												}
											}
										}else{
												// console.log("ADD to workstations 2", dev.manager_id, this.multiples.workstations.includes(dev.manager_id))
											if(!this.multiples.workstations.includes(dev.manager_id)){
												if (!dev.manager_id) {
													this.multiples.workstations.push("my_computer");
												}else{
													this.multiples.workstations.push(dev.manager_id);
												}
											}
										}
									} // dev 
								}
							}else{
								this.multiples = {
									...this.multiples,
									devices 		: [],
									workstations 	: [],
								};
							}
							this.actions("update_component");							
							
							if (this.timeMultiplesDevices) {
								clearTimeout(this.timeMultiplesDevices);
								this.timeMultiplesDevices = null;
							}
							this.timeMultiplesDevices = setTimeout(()=>{
								// this.get_list();
								this.get_search();
								clearTimeout(this.timeMultiplesDevices);
								this.timeMultiplesDevices = null;
							},1000)
						});
					}						
				}else 
				if ( act == "set_workstations_group" ){
					if (item && item.manager_id) {			
					this.$nextTick(()=>{
					// console.log("CHECK ", this.multiples.workstations, item.manager_id);		
						if (this.multiples && this.multiples.workstations && this.multiples.workstations.length > 0) { 
							// case 1  multiples  == all
							if (item.manager_id == 'all' ) {
								if (this.multiples.workstations.includes(item.manager_id)) {
									// console.log("ALL select includes")
									this.multiples= {
										...this.multiples,
										devices 		: this.list_devices.map(x => x.deviceId),
										workstations 	: this.list_workstations.map(x => x.manager_id)
									};
								}else{
									// console.log("ALL select Not includes")

									this.multiples = {
										...this.multiples,
										devices 		: [],
										workstations 	: []
									};
								}
							}
							else if(item.manager_id){ // case 2 multiples 
								if (this.multiples.workstations.includes(item.manager_id)) {
									// console.log(" select includes workstations", item.manager_id)
									let temp_devices =  this.list_devices.map(x =>{
											if (x.manager_id == item.manager_id) {
												return x.deviceId;
											}else if (!x.manager_id && item.manager_id == 'my_computer') {
												return x.deviceId;												
											}
											
										})
									temp_devices = this.multiples.devices.concat(temp_devices);
									this.multiples = {
										...this.multiples,
										devices 		: temp_devices,										
									};
								}else{
									if (this.multiples.workstations.includes("all")) {
										this.multiples.workstations.splice(this.multiples.workstations.indexOf('all'),1) 
									}

									
									// console.log(" select not includes my_computer * ", this.list_devices);
									const valid = this.list_devices.filter(z => { 
												if (item.manager_id == z.manager_id){
													// console.log("Z  ", z.manager_id); 
													return true
												}else if (item.manager_id == 'my_computer' && !z.manager_id){ 
													// console.log("Z  1", z.manager_id); 														
													return true													
												} 
											}).map(x => x.deviceId);
										// console.log("valid ", valid)

										
									this.multiples.devices = this.multiples.devices.filter(x => !valid.includes(x)) 
									
								}	
							}

						}else { // case 3 multiple == 0
							// console.log(" select multupes == 0")

							this.multiples = {
								...this.multiples,
								devices 		: [],
								workstations 	: []
							};
						}

						// console.log("end ", this.multiples)
						
							this.actions("update_component");
							this.get_search();
						})
					}
				}else 
				if (act == "set_smart_event_group") {					
					if (item && item.id) {												
						this.$nextTick(()=>{
							if(this.multiples && this.multiples.smart_events.length > 0){									
								if (item.id == "all") {
									if (this.multiples.smart_events.includes("all")) {
										this.multiples.smart_events = this.list_smart_events.map(x => x.id);
									}else{
										this.multiples.smart_events = [];										
									}
								}
								else if(item.id){
									if (!this.multiples.smart_events.includes(item.id)) {
										if (this.multiples.smart_events.includes("all")) {
											this.multiples.smart_events.splice(this.multiples.smart_events.indexOf("all"))
										}
									}
								}
							}
							this.actions("update_component");
							this.get_search();
						})
					}
				}else
				if (act == "update_component") {
					if (this.layout_id) {						
						this.$emit('update_of_component',{
							component : "events",
							value 	  : { 
								toggle  : { ...this.toggle },
								info    : { ...this.info },
								multiples : { ...this.multiples }, 
							},
							ID 		  : this.layout_id,
						});
					}
				}else
				if ( act == "load_component") {
					if (item) {
						if (item.info) {
							this.info = { ...this.info, ...item.info };							
						}
						if (item.multiples) {
						// console.log("item load", item)
							this.multiples = { ...item.multiples };													
						}
						if (this.multiples) {
							this.$nextTick(()=>{
								
								if (!this.multiples.title) {
									this.multiples.title 			= this.ref;				
								}							
								if (this.multiples.workstations && this.multiples.workstations.length === 0) {
									this.multiples.workstations = ['all'];
								}
								if (this.multiples.devices && this.multiples.devices.length === 0) {
									this.multiples.devices 		= [ 'all'];
								}
								if (this.multiples.smart_events && this.multiples.smart_events.length === 0) {
									this.multiples.smart_events 	= [ 'all'];
								}
							})
						}
					// console.log("load_component ", item)
					}
				}

					
					
					
					
			}, // actions

			set_color_draw(){
				let o    = Math.round, r = Math.random, s = 255;
				let ca   = 'rgba(' + o(r()*s) + ',' + o(r()*s) + ',' + o(r()*s) + ',' + r().toFixed(1) + ',0.5)';
				let num1 = o(r()*s)
				let num2 = o(r()*s)
				let num3 = o(r()*s)

				return 'rgba('+num1+','+num2+','+num3+',0.5)';
			}, // set color draw

			send(val){
				// console.log(val, 'open modal')
				// this.is_open_modal = true;

				// Increment counter when registration is performed
				if (this.ref !== 'counter' && this.ref !== 'mixta' && val && val.id) {
					this.num_events++;
					this.total++;
					console.log('📊 [REGISTRATION] Counter updated - num_events:', this.num_events, 'total:', this.total);
				}

				// Para counter: abrir modal de detalles con búsqueda por rango
				if (this.ref === 'counter') {
					this.openCounterDetails(val,0);
					return;
				}

				if (val && val.formated) {
					this.info_to_modal = val.formated;
				}else{
					console.warn(" No found info additional of item select");
				}
			}, // send

			closeCounterDetails() {
				this.counterDetailsVisible = false;
				this.counterDetailsSession = null;
				this.counterDetailsEvents = [];
				this.counterDetailsLoading = false;
				this.counterDetailsVideoUrl = null;
				this.counterDetailsVideoContextTimestamp = null;
			},

			async openCounterDetails(item) {
				if (!item) return;
				this.counterDetailsSession = item;
				this.counterDetailsVisible = true;
				this.counterDetailsEvents = [];
				this.counterDetailsLoading = true;

				this.counterDetailsVideoUrl = null;
				this.counterDetailsVideoContextTimestamp = null;

				try {
					// Buscar video más cercano al timestamp del counter (si tenemos deviceId)
					const videoInfo = await this.fetchClosestVideoUrlForCounter(item);
					this.counterDetailsVideoUrl = videoInfo && videoInfo.videoUrl ? videoInfo.videoUrl : null;
					this.counterDetailsVideoContextTimestamp = videoInfo && videoInfo.contextTimestamp ? videoInfo.contextTimestamp : null;

					// Fallback legacy: si no se pudo obtener clip por endpoint nuevo, usar el endpoint antiguo por barcode
					if (!this.counterDetailsVideoUrl && item && item.barcode) {
						this.counterDetailsVideoUrl = `${this.$URL}/api/v1/operationsession/video/${item.barcode}`;
					}

					const events = await this.fetchCounterEventsByRange(item);
					this.counterDetailsEvents = Array.isArray(events) ? events : [];
				} catch (err) {
					console.error('❌ [COUNTER-DETAILS] Error loading counter events:', err);
					this.counterDetailsEvents = [];
					this.$EventBus && this.$EventBus.$emit('notifications_modal', {
						type: 'error',
						message: this.$ml.get('error_loading_events') || 'Error al cargar eventos'
					});
				} finally {
					this.counterDetailsLoading = false;
				}
			},

			async fetchClosestVideoUrlForCounter(session) {
				try {
					const deviceId = session && session.deviceId ? String(session.deviceId) : null;
					if (!deviceId) return null;

					const normalizeUnixMs = (value) => {
						const n = typeof value === 'string' ? Number(value) : Number(value);
						if (!isFinite(n) || n <= 0) return NaN;
						// Heurística: < 1e12 probablemente está en segundos (Unix)
						return n < 1e12 ? n * 1000 : n;
					};

					const start = Number(session && session.timestamp_start);
					const end = Number(session && session.timestamp_end);
					let timestamp = start;
					if (isFinite(start) && isFinite(end) && end > start) {
						// usar el punto medio para aumentar probabilidad de match
						timestamp = Math.floor((start + end) / 2);
					}
					if (!isFinite(timestamp) || timestamp <= 0) return null;

					const apiUrl = this.$URL + '/api/v1/records/find_closest_video';
					const payload = { timestamp, deviceId };
					const response = await this.$axios.post(apiUrl, payload);

					const data = response && response.data ? response.data : null;
					const videoOrClosest = (data && data.video) || (data && data.closestVideo) || null;
					let urlpath = videoOrClosest && videoOrClosest.urlpath ? videoOrClosest.urlpath : null;

					// soportar otras formas comunes
					if (!urlpath && data && data.urlpath) urlpath = data.urlpath;
					if (!urlpath && videoOrClosest && videoOrClosest.url) urlpath = videoOrClosest.url;
					if (!urlpath) return null;

					// Usar el inicio real del clip si el backend lo provee; si no, caer al inicio de la sesión
					const clipStartCandidate =
						(videoOrClosest && (videoOrClosest.date ?? videoOrClosest.timestamp_start ?? videoOrClosest.startTimestamp ?? videoOrClosest.start ?? videoOrClosest.start_time ?? videoOrClosest.time_start ?? videoOrClosest.ts_start)) ??
						(data && (data.timestamp_start ?? data.startTimestamp ?? data.start)) ??
						(session && session.timestamp_start) ??
						timestamp;
					const clipStartMs = normalizeUnixMs(clipStartCandidate);

					if (typeof urlpath !== 'string') return null;
					if (urlpath.startsWith('http')) return { videoUrl: urlpath, contextTimestamp: isFinite(clipStartMs) ? clipStartMs : timestamp };
					if (!urlpath.startsWith('/')) urlpath = '/' + urlpath;
					return { videoUrl: this.$URL + urlpath, contextTimestamp: isFinite(clipStartMs) ? clipStartMs : timestamp };
				} catch (error) {
					// no bloquear el modal si el video falla
					return null;
				}
			},

			formatCounterTsForApi(ts) {
				const n = Number(ts);
				if (!isFinite(n) || n <= 0) return null;
				const tz = (this.$Format && (this.$Format.time_guess || this.$Format.timezone)) || this.$timezone;
				try {
					return this.$Format.momentz(n).tz(tz).format('YYYY/MM/DD_HH-mm-ss');
				} catch (e) {
					return null;
				}
			},

			async fetchCounterEventsByRange(session) {
				const startTimestamp = Number(session && session.timestamp_start);
				const endTimestamp = Number((session && session.timestamp_end) || Date.now());
				if (!isFinite(startTimestamp) || !isFinite(endTimestamp) || endTimestamp <= startTimestamp) return [];

				const apiUrl = this.$URL + '/api/v1/records/events_by_range';
				const payload = {
					startTimestamp,
					endTimestamp,
					type: 'smartEvent'
				};

				const res = await this.$axios.post(apiUrl, payload);

				// Soportar distintas formas de respuesta
				let events = [];
				if (res && res.data) {
					if (Array.isArray(res.data)) {
						events = res.data;
					} else if (res.data.events && Array.isArray(res.data.events)) {
						events = res.data.events;
					} else if (res.data.data && Array.isArray(res.data.data)) {
						events = res.data.data;
					} else if (res.data.rows && Array.isArray(res.data.rows)) {
						events = res.data.rows;
					}
				}

				// Filtrar "de ese counter" si tenemos contexto (deviceId / tags)
				const deviceId = session && session.deviceId ? String(session.deviceId) : null;
				const tags = Array.isArray(session && session.totalizers)
					? session.totalizers.map(t => (t && t.tag ? String(t.tag) : null)).filter(Boolean)
					: [];

				let filtered = events;
				if (deviceId) {
					filtered = filtered.filter(ev => {
						const evDevice = ev && (ev.deviceId || (ev.device && ev.device.deviceId));
						return evDevice ? String(evDevice) === deviceId : true;
					});
				}
				if (tags.length > 0) {
					filtered = filtered.filter(ev => (ev && ev.tag) ? tags.includes(String(ev.tag)) : true);
				}

				// Normalizar urls de evidencia (mantener relativo si ya viene con '/')
				return filtered.map(ev => {
					if (ev && ev.url_evidence && typeof ev.url_evidence === 'string') {
						if (!ev.url_evidence.startsWith('http') && !ev.url_evidence.startsWith('/')) {
							ev.url_evidence = '/' + ev.url_evidence;
						}
					}
					return ev;
				});
			},

			// Method to update counter manually
			updateCounter(increment = 1) {
				this.num_events += increment;
				console.log('📊 [COUNTER] Updated - num_events:', this.num_events, 'total:', this.total);
			},

			// Method to reset counter
			resetCounter() {
				this.num_events = 0;
				console.log('📊 [COUNTER] Reset - num_events:', this.num_events, 'total:', this.total);
			},

			// Method to sync counter with backend
			async syncCounterWithBackend() {
				if (this.ref === 'counter') {
					try {
						// Obtener el estado de grabación de parking.vue desde localStorage
						const parkingRecordingStates = localStorage.getItem('parking_recording_states');
						const recordingStates = parkingRecordingStates ? JSON.parse(parkingRecordingStates) : {};
						
						// Filtrar solo los dispositivos que tienen conteo iniciado (startedAt pero no endedAt)
						const activeDevices = Object.entries(recordingStates)
							.filter(([deviceId, state]) => state && state.startedAt && !state.endedAt)
							.map(([deviceId]) => deviceId);
						
						if (activeDevices && activeDevices.length > 0) {
							// Sincronizar cada dispositivo activo
							for (const deviceId of activeDevices) {
								await this.syncDeviceCounterWithBackend(deviceId, recordingStates[deviceId]);
							}
						}
					} catch (error) {
						console.error('❌ [SYNC] Error syncing counter with backend:', error);
						// En caso de error, no hacer nada y continuar
					}
				}
			},

			// Método para sincronizar un dispositivo específico
			async syncDeviceCounterWithBackend(deviceId, recordingState) {
				try {
					const api = this.$URL + '/api/v1/smart_event/stats';
					
					// Usar las fechas de la sesión de grabación
					const startDate = recordingState.startedAt ? new Date(recordingState.startedAt) : new Date(Date.now() - 24 * 60 * 60 * 1000);
					const endDate = new Date();
					
					// Convertir Date objects al formato YYYY-MM-DD que espera format_date_time
					const startDateString = this.$Format.momentz(startDate).format('YYYY-MM-DD');
					const endDateString = this.$Format.momentz(endDate).format('YYYY-MM-DD');
					
					// Formatear fechas correctamente
					const formattedDates = this.$Format.format_date_time([startDateString, endDateString], null, true, false);
					
					// Obtener los tags específicos de este dispositivo desde localStorage
					const parkingDeviceTags = localStorage.getItem('parking_device_tags');
					const deviceTags = parkingDeviceTags ? JSON.parse(parkingDeviceTags) : {};
					const tags = Array.isArray(deviceTags[deviceId]) ? deviceTags[deviceId] : [];
					
					// console.log(`📊 [SYNC-DEVICE] Sincronizando dispositivo ${deviceId} con tags:`, tags);
					
					// Para cada tag del dispositivo, hacer una consulta al backend
					for (const tag of tags) {
						// Validar que el tag sea válido antes de procesarlo
						if (!this.isValidTag(tag)) {
							console.log(`⚠️ [SYNC-DEVICE] Tag inválido ignorado: ${tag}`);
							continue;
						}
						
						// Obtener el ruleId para este tag
						const ruleId = await this.getRuleIdForTag(tag);
						if (!ruleId) {
							console.log(`⚠️ [SYNC-DEVICE] No se encontró ruleId para tag: ${tag}`);
							continue;
						}
						
						const response = await this.$axios.post(api, {
							start: formattedDates.start,
							end: formattedDates.end,
							timeZone: this.$timezone,
							tag: tag,
							deviceId: [deviceId],
							ruleId: ruleId
						});
						
						if (response && response.data && Array.isArray(response.data.rows)) {
							// Buscar el deviceId en la respuesta
							const row = response.data.rows.find(r => r.deviceId === deviceId);
							if (row && row.subtotal !== undefined) {
								const backendCount = parseInt(row.subtotal) || 0;
								console.log(`📊 [SYNC-DEVICE] Dispositivo ${deviceId}, Tag ${tag}: ${backendCount} eventos en backend`);
								
								// Actualizar el contador local si es necesario
								// Esto se puede hacer emitiendo un evento para que parking.vue actualice sus contadores
								this.$EventBus.$emit('update_parking_counter', {
									deviceId: deviceId,
									tag: tag,
									count: backendCount
								});
							}
						}
					}
					
				} catch (error) {
					console.error(`❌ [SYNC-DEVICE] Error syncing device ${deviceId} with backend:`, error);
				}
			},

			// Método auxiliar para obtener ruleId (copiado de parking.js)
			async getRuleIdForTag(tag) {
				try {
					const api = this.$URL + '/api/v1/smart_event';
					const response = await this.$axios.get(api);
					if (response && response.data && Array.isArray(response.data.rows)) {
						const rule = response.data.rows.find(r => r.name && r.name.toLowerCase() === tag.toLowerCase());
						return rule ? rule.id : null;
					}
				} catch (error) {
					console.error('Error getting ruleId for tag:', tag, error);
				}
				return null;
			},

			// Método para validar si un tag es válido
			isValidTag(tag) {
				// Filtrar tags que son muy cortos o no válidos
				if (!tag || typeof tag !== 'string') return false;
				if (tag.length < 2) return false; // Tags de menos de 2 caracteres no son válidos
				if (tag.trim() === '') return false;
				
				// Lista de tags que sabemos que no son válidos
				const invalidTags = ['ju', 'test', 'debug', 'temp'];
				if (invalidTags.includes(tag.toLowerCase())) return false;
				
				return true;
			},

			// Método para actualizar contadores desde parking.vue
			updateCounterFromParking(data) {
				if (!data || !data.deviceId || !data.tagCounters) {
					console.warn('📊 [PARKING-UPDATE] Datos incompletos:', data);
					return;
				}

				const { deviceId, tagCounters, recordingState } = data;

				// Buscar si ya existe una entrada para este dispositivo
				const existingIndex = this.list.findIndex(item => 
					item.device_name === deviceId || 
					(item.barcode && item.barcode.includes(deviceId))
				);

				let barcode = null;
				if (existingIndex >= 0) {
					barcode = this.list[existingIndex].barcode;
				} else {
					// Si no existe, generar un barcode temporal (opcional)
					barcode = `PARKING_${deviceId}`;
				}

				const updatedTotalizers = Object.entries(tagCounters).map(([tag, counters]) => ({
					tag: tag,
					in: counters.in || 0,
					out: counters.out || 0
				}));

				// Emitir evento solo para CounterCell correspondiente
				this.$EventBus.$emit('parking_counter_updated', {
					barcode: barcode,
					totalizers: updatedTotalizers
				});

				// No actualizar this.list ni forzar actualización de la tabla
			},

			// Método para manejar cambios en el estado de grabación
			handleParkingRecordingStateChange(data) {
				if (!data || !data.deviceId) return;

				const { deviceId, recordingState, action } = data;
				
				if (action === 'start') {
					// Iniciar nueva sesión de grabación
					console.log('📊 [PARKING-RECORDING] Iniciando nueva sesión para:', deviceId);
					
					// Crear nueva entrada para la sesión
					const deviceName = this.render_device(deviceId) || deviceId;
					const barcode = `PARKING_${deviceId}_${Date.now()}`;
					
					const newItem = {
						id: barcode,
						barcode: barcode,
						device_name: deviceName,
						inicio: this.$Format.momentz(new Date()).format('YYYY-MM-DD HH:mm:ss'),
						fin: null,
						duration: '00:00:00',
						totalizers: [],
						state: 'En progreso',
						state_icon: 'mdi-record-circle'
					};

					// Agregar al inicio de la lista
					this.list.unshift(newItem);
					this.num_events++;

					console.log('📊 [PARKING-RECORDING] Nueva sesión creada:', newItem);
					
				} else if (action === 'stop') {
					// Finalizar sesión de grabación
					console.log('📊 [PARKING-RECORDING] Finalizando sesión para:', deviceId);
					
					// Buscar la entrada más reciente para este dispositivo
					const existingIndex = this.list.findIndex(item => 
						item.device_name === deviceId || 
						(item.barcode && item.barcode.includes(deviceId))
					);

					if (existingIndex >= 0) {
						const existingItem = this.list[existingIndex];
						
						// Actualizar con la información de finalización
						this.list.splice(existingIndex, 1, {
							...existingItem,
							fin: this.$Format.momentz(new Date()).format('YYYY-MM-DD HH:mm:ss'),
							duration: this.calculateDuration(recordingState),
							state: 'Finalizado',
							state_icon: 'mdi-check-circle'
						});

						console.log('📊 [PARKING-RECORDING] Sesión finalizada:', this.list[existingIndex]);
					}
				}
			},

			// Método auxiliar para calcular duración
			calculateDuration(recordingState) {
				if (!recordingState || !recordingState.startedAt) return '00:00:00';
				
				const startTime = new Date(recordingState.startedAt);
				const endTime = recordingState.endedAt ? new Date(recordingState.endedAt) : new Date();
				const durationMs = endTime - startTime;
				
				const hours = Math.floor(durationMs / (1000 * 60 * 60));
				const minutes = Math.floor((durationMs % (1000 * 60 * 60)) / (1000 * 60));
				const seconds = Math.floor((durationMs % (1000 * 60)) / 1000);
				
				return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
			},

			close_modal(item){
				this.info_to_modal = null;
			}, // close modal

			get_status(table){
				// Evitar memory leak: guardar handlers y hacer $off en beforeDestroy/cambio de tabla
				if (!this.bus_channels) this.bus_channels = {};

				// Listener global (solo una vez)
				if (!this.bus_channels['status_connections']) {
					this.bus_channels['status_connections'] = (states) => {
						if (states && states['data']) {
							this.color_message  = states['data'].color;
							this.status_message = states['data'].status;
						}
					};
					EventBus.$on('status_connections', this.bus_channels['status_connections']);
				}

				// Listener por tabla (reemplazar si cambia)
				const statusEventName = 'status_event' + table;
				if (this.current_status_event_name && this.bus_channels[this.current_status_event_name]) {
					EventBus.$off(this.current_status_event_name, this.bus_channels[this.current_status_event_name]);
				}
				this.current_status_event_name = statusEventName;
				this.channel_bus = table;

				this.bus_channels[statusEventName] = (action) => {
					if (action) {
						this.color_message  = action.color;
						this.status_message = action.status;
					}
				};
				EventBus.$on(statusEventName, this.bus_channels[statusEventName]);
				EventBus.$emit('get_status_event', table);

			}, // get status

			fetchMixtaListFromApis() {
				const vm = this;
				if (this.ref !== 'mixta') return;
				if ((this.selected_tags && this.selected_tags.length > 0) || this.search) {
					return;
				}
				this.loading = true;
				const base = this.$URL;
				const pg = 1;
				this.mixta_source_counts = {
					lpr         : 0,
					avc         : 0,
					smart_event : 0,
					alarms      : 0,
				};
				const paths = [
					['lpr', '/api/v1/lpr/event/'],
					['avc', '/api/v1/avc/'],
					['smart_event', '/api/v1/smart_event/'],
					['alarms', '/api/v1/alerts/'],
				];
				axios.defaults.withCredentials = false;
				Promise.all(
					paths.map(([key, path]) =>
						axios
							.get(`${base}${path}?page=${pg}`)
							.then((res) => {
								const rows = res.data && Array.isArray(res.data.rows) ? res.data.rows : [];
								const count = parseInt(res.data && res.data.count, 10);
								const n = Number.isFinite(count) && count >= 0 ? count : 0;
								return { key, rows, count: n };
							})
							.catch((err) => {
								console.warn('[mixta] API error', key, err && err.message);
								return { key, rows: [], count: 0 };
							})
					)
				)
					.then((results) => {
						const fromApi = [];
						const seenApi = {};
						results.forEach(({ key, rows, count }) => {
							if (key && vm.mixta_source_counts && {}.hasOwnProperty.call(vm.mixta_source_counts, key)) {
								vm.mixta_source_counts[key] = count || 0;
							}
						});
						results.forEach(({ key, rows }) => {
							rows.forEach((j) => {
								if (!vm.render_hostname(j)) return;
								const info = vm.formatEventInfo(j, key);
								if (!info || !info.formated) return;
								const row = vm.buildMixtaRow(info, key, j);
								if (!row || !row.id || seenApi[row.id]) return;
								seenApi[row.id] = true;
								fromApi.push(row);
							});
						});
						const fromSocket = (vm.list || []).filter((r) => r && r.id && !seenApi[r.id]);
						const merged = fromApi.concat(fromSocket);
						vm.mixtaSortListByDateDesc(merged);
						const maxB = Math.max(10, parseInt(vm.mixta_max_buffer, 10) || 200);
						vm.list = merged.slice(0, maxB);
						vm.eventosPorId = {};
						vm.list.forEach((r) => {
							if (r && r.id) vm.eventosPorId[r.id] = r;
						});
					})
					.finally(() => {
						vm.loading = false;
					});
			},

			get_list(){
				if (this.ref === 'mixta') {
					if ((this.selected_tags && this.selected_tags.length > 0) || this.search) {
						this.loading = false;
						return;
					}
					this.fetchMixtaListFromApis();
					return;
				}
				// this.show.filters 			
				if ((this.selected_tags && this.selected_tags.length > 0) || this.search ) { /*this.show.search_text || this.show.search_tag ||*/ 
					// console.log("searching ************************** EVENTS ", this.show.search_text, this.show.search_tag, this.search, this.selected_tags )
					this.get_search();
				}else{

				let pg 	= 1, 
					sw 	= 0,
					url_req = '/api/v1/motion/';

				if (this.relayIoHistoryView) {
					this.loading = true;
					this.list = [];
					this.list_off = [];
					this.fetchRelayIoStateHistoryList();
					return;
				}

				this.loading 	= true;
				// For technical tab, keep existing rows visible during reload (don't flash blank).
				// The API response will replace the list once it arrives.
				if (this.ref !== 'technical') {
					this.list = [];
				}
				this.list_off 	= [];

				if (!this.multiples.devices.includes("all") ) {
					// console.log("DO SEARCH ", this.multiples.devices)
					this.get_search()
					return 
				}

				const  { page, itemsPerPage } = this.options;

					if (this.ref === "access_control") {
						this.get_search();
						return;
					}

					if (itemsPerPage == 15) {
						if (page % 2 == 0) {
							pg 	= (page/2);
							sw 	= 2;
						}else{
							pg  = parseInt(page/2)+1;
							sw 	= 1;
						}
					}else{
						pg 		= page
					}

					if (this.ref == 'alerts') {
						url_req 	= '/api/v1/eventAlerts/';
					}else if (this.ref == 'lpr') {
						url_req 	= '/api/v1/lpr/event/'
					}else if (this.ref == 'weapon_detector'){
						url_req 	= '/api/v1/alertgun/';
					}else if (this.ref == 'alarms'){
						url_req 	= '/api/v1/alerts/'
					}else if (this.ref == 'objects'){
						url_req = '/api/v1/object/';
					}else if (this.ref == 'actions'){
						url_req = '/api/v1/actions/';
					}else if(this.ref == 'technical'){
						url_req = '/api/v1/technical_records/';
					}else if(this.ref == 'smart_event'){
						url_req = '/api/v1/smart_event/';
					}else if (this.ref == "peripherals"){
						url_req = '/api/v1/logs_peripherals/';
					}else if (this.ref == "incidents"){
						url_req = '/api/v1/management_incident/';
					}else if (this.ref == "parking") {
						url_req = '/api/v1/register_event_parking/';
					}else if (this.ref == "audios") {
						url_req = '/api/v1/audio/';
					}else if (this.ref.includes("face")){
						url_req = '/api/v1/face/';
						if (this.info.subtitle == "recognized") {
							url_req = '/api/v1/face_reconized/';
						}
					}else if (this.ref == "avc") {
						url_req = '/api/v1/avc/';
					}else if (this.ref == "counter"){
						url_req = '/api/v1/operationsession/';
						// console.log('📊 [COUNTER-LIST] Loading counter data from:', url_req);
					}else if (this.ref == "access_control"){
						url_req = '/api/v1/access-control/events/';
					}

					const	api = this.$URL + url_req + '?page=' + pg ;
					if (this.ref === 'counter') {
						// console.log('📊 [COUNTER-LIST] Making API request to:', api);
					}
					axios.defaults.withCredentials 	= 	false;

					axios.get(api).then( response => {
						if (this.ref === 'counter') {
							// console.log('📊 [COUNTER-LIST] API response received:', response.data);
						}
						// console.log("RES EVENT TABLE ****************", response )
						let items  				= response.data.rows;
						this.total 				= parseInt(response.data.count); //  res.data.pages; //
						this.total_view_toggle 	= response.data.pages; //
						this.loading 			= false;

						if (items && items.length > 0) {
							this.last_total = this.total;
							if (this.ref === 'counter') {
								// console.log('📊 [COUNTER-LIST] Found', items.length, 'items, total:', this.total);
							}

							if (itemsPerPage <= 15) {
								if (sw == 1) {
									items = items.slice((sw - 1) * itemsPerPage, sw  + itemsPerPage );
								}else if (sw == 2) {
									items = items.slice(15, 30 );
								}
							}
							let list_new = [];
							
							for(let j of items){
								if (this.render_hostname(j)) {
									if (this.ref === 'counter') {
										// console.log('📊 [COUNTER-LIST] Processing item:', j);
									}

									let info_list = this.formatEventInfo(j, this.ref);
									if (this.ref === 'counter') {
										// console.log('📊 [COUNTER-LIST] Formatted item:', info_list);
									}
									if (info_list) {
										// console.log("DRAW ROI EVENT 1 ",info_list);	
										list_new.push(info_list);
										if (info_list.formated && info_list.formated.content && info_list.formated.content.bbox) {
											this.actions("draw_bbox", {...info_list.formated});
										}
									}
									
								}
							}
							// if (!this.is_reports) {
							if (list_new && list_new.length > 0) {
								if (this.ref === 'counter') {
									// console.log('📊 [COUNTER-LIST] Adding', list_new.length, 'formatted items to list');
								}

								// Filtrar duplicados antes de agregar a la lista
								const uniqueItems = list_new.filter((item, index, self) => {
									if (this.ref === 'counter') {
										// Para counter, usar barcode como identificador único
										const barcode = item.barcode;
										if (!barcode) return true; // Si no tiene barcode, permitir (será filtrado después)
										
										// Verificar si ya existe en la lista actual
										const existingInCurrentList = this.list.find(existing => existing.barcode === barcode);
										if (existingInCurrentList) {
											console.log('📊 [COUNTER-LIST] Duplicate barcode found in current list, skipping:', barcode);
											return false;
										}
										
										// Verificar si ya existe en los nuevos items (más reciente primero)
										const firstIndex = self.findIndex(t => t.barcode === barcode);
										return index === firstIndex;
									} else {
										// Para otros tipos, usar id como identificador único
										const id = item.id;
										if (!id) return true; // Si no tiene id, permitir (será filtrado después)
										
										// Verificar si ya existe en la lista actual
										const existingInCurrentList = this.list.find(existing => existing.id === id);
										if (existingInCurrentList) {
											console.log('📊 [COUNTER-LIST] Duplicate ID found in current list, skipping:', id);
											return false;
										}
										
										// Verificar si ya existe en los nuevos items (más reciente primero)
										const firstIndex = self.findIndex(t => t.id === id);
										return index === firstIndex;
									}
								});

								// Filtrar items sin identificador válido
								const validItems = uniqueItems.filter(item => {
									if (this.ref === 'counter') {
										return item.barcode && item.barcode.trim() !== '';
									} else {
										return item.id && item.id.toString().trim() !== '';
									}
								});

								if (this.ref === 'counter') {
									console.log('📊 [COUNTER-LIST] Filtered', list_new.length, 'items to', validItems.length, 'unique items');
								}

								// For technical tab: replace the list cleanly (we kept stale rows visible
								// during loading instead of blanking — now swap them out).
								if (this.ref === 'technical') {
									this.list = validItems;
								} else {
									this.list = this.list.concat(validItems);
									// Limpiar duplicados después de agregar nuevos items
									this.cleanupDuplicates();
								}
								this.fetch_cloud_status(validItems);
								if (this.ref === 'counter') {
									// console.log('📊 [COUNTER-LIST] Final list length:', this.list.length);
								}
								
								// console.log('searching found check_list get ', list_new, this.list);

							}
						}else{
							if (this.ref === 'counter') {
								// console.log('📊 [COUNTER-LIST] No items found in response');
							}
							/*
							if (this.total == 0) {
								EventBus.$emit('notifications_modal',{
									type    : 'warning',
									message : this.$ml.get('data_no_found')
								});
							}else{

								EventBus.$emit('notifications_modal',{
									type    : 'warning',
									message : this.$ml.get('no_info_page')
								});
							}
								*/
						}
						// EventBus.$emit('logs', response.data);
						
					}).catch( error => {
						if (this.ref === 'counter') {
							// console.error('📊 [COUNTER-LIST] Error loading counter data:', error);
						}
						console.log("Error get list event : ", error)

						this.loading = false;
					})
				}
			}, //get_list

			formatRelayIoStateCell(val) {
				if (val === null || val === undefined) {
					return '—';
				}
				if (val === true || String(val).toLowerCase() === 'true' || val === 1) {
					return 'ON';
				}
				if (val === false || String(val).toLowerCase() === 'false' || val === 0) {
					return 'OFF';
				}
				return String(val);
			},

			fetchRelayIoStateHistoryList() {
				if (!this.relayIoHistoryView || !this.host_from) {
					this.loading = false;
					return;
				}
				this.loading = true;
				const { page, itemsPerPage } = this.options;
				const limit = Math.min(Number(itemsPerPage) || 30, 200);
				const pg = page || 1;
				axios.defaults.withCredentials = false;
				this.$axios
					.get(`${this.$URL}/api/v1/relay_io_state_histories`, {
						params: {
							deviceId: this.host_from,
							page: pg,
							limit
						}
					})
					.then(res => {
						const raw = res.data || {};
						const body = raw.rows !== undefined ? raw : raw.data || {};
						const rows = Array.isArray(body.rows) ? body.rows : [];
						this.total = typeof body.count === 'number' ? body.count : rows.length;
						this.total_view_toggle =
							typeof body.pages === 'number'
								? body.pages
								: Math.max(1, Math.ceil(this.total / limit));
						this.last_total = this.total;
						const vm = this;
						this.list = rows.map(r => ({
							...r,
							date:
								r.createdAt && vm.$Format && vm.$Format.momentz
									? vm.$Format.momentz(r.createdAt).format('YYYY-MM-DD HH:mm:ss')
									: (r.createdAt || ''),
							previousState: vm.formatRelayIoStateCell(r.previousState),
							newState: vm.formatRelayIoStateCell(r.newState)
						}));
						this.loading = false;
					})
					.catch(() => {
						this.list = [];
						this.total = 0;
						this.total_view_toggle = 0;
						this.loading = false;
					});
			},

			onRelayIoStateHistorySocket(message) {
				if (!this.relayIoHistoryView || !this.host_from) {
					return;
				}
				if (message && message.success === false) {
					return;
				}
				const data = message && message.data !== undefined ? message.data : message;
				if (!data || data.deviceId === undefined || data.deviceId === null) {
					return;
				}
				if (String(data.deviceId) !== String(this.host_from)) {
					return;
				}
				if (this.relayIoHistoryRefreshTimer) {
					clearTimeout(this.relayIoHistoryRefreshTimer);
				}
				this.relayIoHistoryRefreshTimer = setTimeout(() => {
					this.relayIoHistoryRefreshTimer = null;
					this.fetchRelayIoStateHistoryList();
				}, 350);
			},

			get_search(find){
				if (this.ref === 'mixta') {
					this.loading = false;
					return;
				}
				if (this.relayIoHistoryView) {
					this.fetchRelayIoStateHistoryList();
					return;
				}
				// find.preventDefault();
				let pg 	= 1 , 
					sw 	= 0,
					url = '/api/v1/event/find/';

				const { page, itemsPerPage } = this.options;
				this.loading 				 = true;

				if (itemsPerPage==15) {
					if (page % 2 == 0) {
						pg 	= (page/2);
						sw 	= 2;
					}else{
						pg 	= parseInt(page/2)+1;
						sw 	= 1;
					}
				}else{
					pg 		= page;
				}

				let data_where = {};
				if (this.show.search_text) {
					if (this.ref == "avc") {
						data_where["vehicle_type"] = this.search; // 													
					}else if (this.ref == "counter") {
						data_where["barcode"] = this.search; // Búsqueda por barcode para counter
						// console.log('📊 [COUNTER-SEARCH] Searching for barcode:', this.search);
					}else{
						data_where["plate_char"] = this.search; // 							
					}
				}				
				if (this.multiples && this.multiples.smart_events && this.multiples.smart_events.length > 0) {
					data_where.rulesId 	= this.multiples.smart_events.filter(x => (x && typeof x == 'number'));
					// console.log("multiples.smart_events ", this.multiples.smart_events)
				}
				if (this.show.filters) {
					// console.log("Check filters post ", this.info_date, this.info_device)
					if (this.show.search_tag) {
						let tags 	= [...this.selected_tags ]; // find
						data_where.rulesId 	= tags.filter(x => (x && typeof x == 'number'));
						data_where.tags 	= tags.filter(z => (z != 'lpr' && typeof z != 'number'))
							
						/*let idx 			= data_where.tags.findIndex(x => x == 'lpr' );
						if (idx >= 0) {
							data_where.tags.splice(idx,1);
						}*/
					}
					if (this.info_date && this.info_date.length > 0) {
						// console.log("TIMER ", this.info_search)
						let datess = this.$Format.format_date_time(this.info_date, this.info_search, true, false);
						if (datess == 'required_range_24h') {
			    			this.$EventBus.$emit('notifications_modal',{
			    				type 	: 'warning',
			    				message : this.$ml.get('required_range_24h')
			    			})
			    			return false
		    			}
						data_where.start 	= datess.start;
						data_where.end 		= datess.end;
					}
					
					if (this.info_device) {
						data_where.deviceId = this.info_device;	
					}

					data_where.timeZone 	= this.$timezone;
				}else
				if(this.multiples && this.multiples.devices && this.multiples.devices.length > 0){
					data_where.deviceId = this.multiples.devices;
				}

				if (this.ref == 'smart_event' && data_where.plate_char && !data_where.start && !data_where.end) {
					let datess = this.$Format.format_date_time(null, null, true, false);
					data_where.start 	= datess.start;
					data_where.end 		= datess.end;
					data_where.timeZone 	= this.$timezone;
				}

				if (this.ref == 'alerts') { // lpr
					url 	= '/api/v1/alerts-plate/find/'; //+data_where.plate_chars+
				}else if (this.ref == 'lpr') {
					url 	= '/api/v1/lpr/find/plate/'; //  post / event/find
				}else if (this.ref == 'weapon_detector'){
					url 	= null;//'/api/v1/alertgun/';
				}else if (this.ref == 'alarms'){
					url 	= '/api/v1/alerts/find';
					// delete data_where.plate_chars;
				}else if (this.ref == 'objects'){
					url = '/api/v1/object/find';

				}else if(this.ref == 'technical'){
					url = '/api/v1/technical_records/find';

				}else if(this.ref == 'smart_event'){
					url = '/api/v1/smart_event/find';
				
				}else if (this.ref == "peripherals"){
					url = '/api/v1/find_peripherals/';

				}else if (this.ref == 'motion'){
					url = '/api/v1/motion/find';

				}else if (this.ref == 'actions'){
					url = '/api/v1/actions/find';
				}
				else if (this.ref == 'incidents') {
					url = '/api/v1/management_incident/find/';
				}else if (this.ref == 'parking'){
					url = '/api/v1/register_event_parking/find/plate/';

				}else if (this.ref == "audios") {
					url = '/api/v1/audio/find/';
				}else if (this.ref == "face") {
					url = '/api/v1/face/find/';
				}else if (this.ref == "avc") {
					url = '/api/v1/avc/find/'
				}else if (this.ref == "counter") {
					url = '/api/v1/operationsession/find/';
					// console.log('📊 [COUNTER-SEARCH] Using search URL:', url);
				}else if (this.ref == "access_control") {
					url = '/api/v1/access-control/events/find/';
				}

				if (this.ref === 'counter') {
					// console.log("📊 [COUNTER-SEARCH] data_where", data_where);
				}
				
					
				const api 	= this.$URL + url + '?page=' + pg;
				if (this.ref === 'counter') {
					// console.log('📊 [COUNTER-SEARCH] Making search request to:', api);
				}
				this.$axios.post(api, { data_where }).then( res =>{
					if (this.ref === 'counter') {
						// console.log('📊 [COUNTER-SEARCH] Search response received:', res.data);
					}
					// console.log(res, 'res search');
					
					this.total 				= parseInt(res.data.count); // 
					this.total_view_toggle 	= res.data.pages; //
					
					let items 		= res.data.rows;
					let list_new 	= [];
					if (items && items.length > 0){
						this.last_total 		= this.total;
						if (this.ref === 'counter') {
							// console.log('📊 [COUNTER-SEARCH] Found', items.length, 'items in search');
						}

						if (itemsPerPage <= 15) {
							items 		= items.slice((sw - 1) * itemsPerPage, sw  + itemsPerPage );
						}

						
						for(let j of items){				
							if (this.ref === 'counter') {
								// console.log('📊 [COUNTER-SEARCH] Processing search item:', j);
							}
							let info_list = this.formatEventInfo(j, this.ref);
							if (this.ref === 'counter') {
								// console.log('📊 [COUNTER-SEARCH] Formatted search item:', info_list);
							}
							// console.log("check ***** format ", info_list, this.ref)
							if (info_list) {
								list_new.push(info_list);
								if (info_list.formated && info_list.formated.content && info_list.formated.content.bbox) {
									this.actions("draw_bbox", {...info_list.formated});
								}
							}		
						}
						// Filtrar duplicados en los resultados de búsqueda
						const uniqueSearchItems = list_new.filter((item, index, self) => {
							if (this.ref === 'counter') {
								// Para counter, usar barcode como identificador único
								return index === self.findIndex(t => t.barcode === item.barcode);
							} else {
								// Para otros tipos, usar id como identificador único
								return index === self.findIndex(t => t.id === item.id);
							}
						});
						
						this.list_search = uniqueSearchItems;
						if (this.ref === 'counter') {
							// console.log('📊 [COUNTER-SEARCH] Search results added to list_search, length:', this.list_search.length);
						}
						// console.log('searching found check_list ', list_new);
						if (this.is_reports) {
							// this.total 	 = this.total_report;
							// console.log('total report in eventss')
						}
					}else{
						if (this.ref === 'access_control') {
							this.list_search = [];
							this.list = [];
						}
						if (this.ref === 'counter') {
							// console.log('📊 [COUNTER-SEARCH] No items found in search results');
						}
						if (this.total == 0) {
							EventBus.$emit('notifications_modal',{
								type    : 'warning',
								message : this.$ml.get('data_no_found')
							});
						}else{

							EventBus.$emit('notifications_modal',{
								type    : 'warning',
								message : this.$ml.get('no_info_page')
							});
						}
					}
					this.loading 	 = false;
				}).catch(error => {
					if (this.ref === 'counter') {
						// console.error('📊 [COUNTER-SEARCH] Error in search:', error);
					}
					if (this.ref === 'access_control') {
						this.list_search = [];
						this.list = [];
					}
					console.log(error);
					this.loading 	 = false;
				} );
			}, // get search

			

			onResize() {
				// console.log(this.height, '	events1')

				if (this.$refs && this.$refs['card' + this.layout_id]) {

					let size 	  = 180;
					let is_filter = this.show && this.show.filters ? true : false;
					// Misma lógica que otras tablas: más “chrome” arriba = más restar (toolbar del feed mixto)
					const mixtaToolbar = this.ref === 'mixta' ? 120 : 0;
					if(this.height < 56){
						size 		= this.show_search && !is_filter ? 130 : is_filter ? 170 : 180;
						
					 	this.height = this.$refs['card' + this.layout_id].clientHeight - size - mixtaToolbar;
					 	// document.getElementById("card")

					}else{
						// this.height=this.$refs.card.clientHeight-170;// 145
						// console.log(this.$refs.card.clientWidth, this.$refs.card.clientHeight, 'width')
						if (this.$refs['card' + this.layout_id].clientWidth < 429) {
							size 		=  this.show_search && !is_filter ? 135 : is_filter ? 180 : 130;
							this.height = this.$refs['card' + this.layout_id].clientHeight - size - mixtaToolbar;
						}else{
							size 		=  this.show_search && !is_filter ? 135 : is_filter? 180 : 90;
							this.height = this.$refs['card' + this.layout_id].clientHeight - size - mixtaToolbar;
						}
						// console.log(this.height, 'events2')
						// this.height=70	;

					}
					if (this.resize_to_component) {
						size 		= this.show_search && !is_filter ? 150 : is_filter ? 200 : 110;
						// console.log("check ****************************** ", size, this.resize_to_component)
						this.height = this.resize_to_component - size - mixtaToolbar;
					}

					// console.log("Height ----------------> ", this.$refs['card' + this.layout_id].clientHeight, this.height, size)
				}
			}, //on Resize

			onScroll (e) {
    			this.offsetTop = e.target.scrollTop
  			},
  			
			onChange(input) {
		      this.input  = input;
		      this.search = input.toUpperCase();
		    },
		    onKeyPress(button) {
		      // console.log("button", button);
		      if (button == '{enter}') {
		      	this.get_search(this.search);
		      }
		    },
		    onInputChange(input) {
		      this.input = input.target.value;
		      // this.search=input;
		    },
		    keyboard_is_active(){
		    	let key_board = false;
		    	if (localStorage.getItem('virtual_Key_board')) {
					key_board = JSON.parse(localStorage.getItem('virtual_Key_board'));
				}
				// console.log(key_board, 'before condition')
		    	if (key_board == true) {
		    		this.sheet = true;
		    		// console.log(key_board, this.sheet, 'while condition')
		    	}

		    	// console.log(key_board, this.sheet, 'activate key_board')
		    },	

		    filter_search(val){
		    	let list = [];
		    	let vm   = this;
		    	if (vm.list_tags && vm.list_tags.length > 0) {		    				    		
			    	list 	 = vm.list_tags.filter( filter_tag => {			    		
			    		return filter_tag && filter_tag.text && filter_tag.text.toLowerCase().indexOf(val) > -1
			    	}) 
		    	}

		    	this.render_tags = list;
		    }, // filter search

  			// 	SEARC(searching){
			// 	return this.get_search(searching);
			// }, 

			render_hostname(val){
  				let hostname = "";
  				// console.log(this.$router.currentRoute.name, 'route', val, '== ?', this.host_from )
  				
  				if (this.$router.currentRoute.name == 'setting_device' || 
  					this.$router.currentRoute.name == 'setting_analytic'){ //  host_configuration
  					if (val.device && val.device.deviceId) {
  						hostname = val.device.deviceId
  					}else if (val.deviceId) {
  						hostname = val.deviceId;
  					}
  					if ( this.host_from ==  hostname) { //
  						// hostname=this.host_config;
  						return true
  					}else{
  						return false
  					}
  				}else{
  					// Para eventos counter, permitir todos sin filtrar por dispositivo
  					if (this.ref === 'counter') {
  						return true;
  					}
  					
  					let manager_id = "";
  					let check 	   = false;
  					let ruleId 	   = val && val.ruleId ? val.ruleId : null;
  					let check_event = false;
  					if (val) {
	  					if (val.device) {

	  						if (val.device.deviceId) {
	  							hostname = val.device.deviceId;
	  						}else if (val.deviceId) {
	  							hostname = val.deviceId;
	  						}
	  						if (val.device.manager_id) {
	  							manager_id = val.device.manager_id;
	  						}

	  					}else{

							if (val.deviceId) {
								hostname = val.deviceId;
							}else if (val.hostId) {
								hostname = val.hostId;						
							}
							if (val.manager_id) {
	  							manager_id = val.manager_id;							
							}
	  					} 
  					}

					if (this.multiples) {
						// check devices
						if (this.multiples.devices.length > 0 && (this.multiples.devices.includes("all") || this.multiples.devices.includes(hostname))) {
							check = true;
						}				    		
							// check managers
							/*if (this.multiples.workstations.length > 0 && (this.multiples.workstations.includes(manager_id) || (this.multiples.workstations.includes("my_computer") && !manager_id))) {
								check = true; 
							}*/			    		
						
			    		if (['alarms', 'smart_event'].includes(this.ref) && check) {
				    		if (this.multiples.smart_events.length > 0 && (this.multiples.smart_events.includes('all') || this.multiples.smart_events.includes(ruleId))) {
				    			check_event = true;
				    		}
			    		}else{
				    		check_event = true;
			    		}
			    		// console.log("PASS ", check, check_event,manager_id,  this.multiples.devices.includes("all") ||this.multiples.devices.includes(hostname), this.multiples.workstations.includes(manager_id), this.$Format.render_device(hostname).name);

						if (this.ref === 'alarms') {
							// Removed [ALARMS-HOSTNAME] log
						}

						if (this.ref === 'counter') {
							console.log('📊 [COUNTER-HOSTNAME] Checking hostname for counter event:', {
								hostname,
								manager_id,
								check,
								check_event,
								devices: this.multiples.devices,
								includes_all: this.multiples.devices.includes("all"),
								includes_hostname: this.multiples.devices.includes(hostname)
							});
						}

						return check && check_event;
					}

  				}
  				return true
  				// return !hostname;
  			},
  			
			check_repeated(item){
				
				if (this.list && this.list.length > 0 && item && item.id) {
					
					let idx = this.list.findIndex(x => (x && x.id == item.id));
					if (idx >= 0) {
						if (this.ref == "parking") {
							return idx;
						}
						return false;
					}
				}
				return true
			}, // check repeated


			render_device(val){
				if (this.list_devices && this.list_devices.length > 0) {
					let vm 	   = this,
						device = ''	;

					const find = vm.list_devices.some( function (dev, idx_dev){
						if (dev.deviceId == val) {
							device = dev.name;
							return true
						}
					}) 

					return device;
				}
				return '';
			}, // render_device

			render_listed(){
				if (!this.toggle.show) {
					return this.list_render;
				}
			}, // render listed

			render_listeds(item){
				if (item && this[item] && this[item].length > 0 ) {
					return this[item];
				}else{
					return []
				}
			}, // render listeds


			render_options_reports(key){
				// console.log("Checkkey : ", key)
				if (key && key != "hide_filters" && key != "show_filters") {
					let idx = this.btn_options.findIndex(x => (x && x.key == key));
					if (idx >= 0) {
						this.btn_options[idx].enable = !this.btn_options[idx].enable;
					}
				}else if(key == "hide_filters"){
					this.show.filters 			= false;
					this.btn_options[0].enable 	= true; // show
					this.btn_options[1].enable 	= false;  // hide


				}else if(key == "show_filters"){
					this.show.filters 			= true;
					this.btn_options[0].enable  = false; // show
					this.btn_options[1].enable 	= true;  // hide
				}	
				else{
						// console.log("check route ", this.$route.name)
					if (this.$route) {
						if (this.$route.name == 'dashboard') {

						}else if(this.$route.name == 'reports'){
							this.btn_options[0].enable = true; // show
							this.btn_options[1].enable = false;  // hide
							this.btn_options[2].enable = false; // redirect
							this.btn_options[3].enable = true;  // pdf
							this.btn_options[4].enable = true;  // excel
							this.$nextTick(()=>{
								this.actions('show_search');
							})
						}
					}
				}

			}, // render_options_reports
			
			render_default_tags(){
				if (default_tags && default_tags.length > 0) {
					
					default_tags.filter(x =>  {
						if (x && x.is_tag){
							this.list_tags.push({ 
								id   : x.key,
								text : x.text
							});
						} 
					})
					

				}
				if (this.$SmartEvent && !this.no_render_default_tags.includes(this.ref)) {
						// console.log("smart_event ", this.$SmartEvent.get_tags())
					this.list_tags = this.list_tags.concat(this.$SmartEvent.get_tags());
						// console.log("smart_event 1 ", this.list_tags)
				}

				this.render_tags = this.list_tags;
			}, // render_default_tags

			render_names_multiples(items, key){
				let temp = [];				
				if (items) {					
					if (key == "smart_events") {
						this.list_smart_events.forEach((it)=>{
							if (items.includes(it.id)){
								temp.push(it.name);
							}
						})
					}else if (key == "devices") {
						this.list_devices.forEach((it)=>{
							if (items.includes(it.deviceId)){
								temp.push(it.name);
							}
						})
					}else if (key == "workstations"){

						this.list_workstations.forEach((it)=>{
							if (items.includes(it.manager_id)){
								temp.push(it.name);
							}
						})
					}else if (key == "title") {
						temp = items;
						
					}					
				}
				return temp;
			}, // render names multiples

			render_len_multiples(item){
				// console.log("CHECK count multiples ", item)
				if (item == "workstations") {
					return this.multiples.workstations.length;
				}else if (item == "devices") {
					return this.multiples.devices.length;
				}else if (item == "title"){
					return 1;
				}else if (item == "smart_events") {
					return this.multiples.smart_events.length;
				}
			}, // render_len_multiples

			paint_tags_colors(tags){
				// ... existing code ...
			},

			// Método para obtener el label dinámico del campo de búsqueda
			getSearchLabel() {
				if (this.ref === 'counter') {
					return this.$ml.get('barcode') || 'Barcode';
				} else if (this.ref === 'avc') {
					return this.$ml.get('vehicle_type') || 'Vehicle Type';
				} else if (this.ref === 'mixta') {
					return this.$ml.get('mixta_filter_placeholder');
				} else {
					return this.$ml.get('search') || 'Search';
				}
			},

			downloadRowPdf(item) {
			  // Lazy load jsPDF and autotable if not already loaded
			  Promise.all([
			    import('jspdf'),
			    import('jspdf-autotable')
			  ]).then(([jsPDFModule, autoTableModule]) => {
			    const jsPDF = jsPDFModule.jsPDF || jsPDFModule.default;
			    const doc = new jsPDF();
			    const autoTable = autoTableModule.default || autoTableModule;

			    // Datos principales
			    const device = item.device_name || item.device || '';
			    const barcode = item.barcode || '';
			    const inicio = item.inicio || '';
			    const fin = item.fin || '';
			    const duration = item.duration || '';
			    const totalizers = item.totalizers || [];

			    // Agregar código de barras en la parte superior derecha
			    if (barcode) {
			      // Posición del código de barras (esquina superior derecha)
			      const barcodeX = 170; // Posición X (cerca del margen derecho)
			      const barcodeY = 20;  // Posición Y (cerca del margen superior)
			      
			      // Configurar fuente para el código de barras
			      doc.setFontSize(10);
			      doc.setTextColor(0, 0, 0);
			      
			      // Dibujar un rectángulo de fondo para el código de barras
			      doc.setFillColor(255, 255, 255);
			      doc.rect(barcodeX - 5, barcodeY - 5, 35, 15, 'F');
			      
			      // Dibujar borde del código de barras
			      doc.setDrawColor(0, 0, 0);
			      doc.rect(barcodeX - 5, barcodeY - 5, 35, 15);
			      
			      // Agregar el texto del código de barras
			      doc.text(barcode, barcodeX, barcodeY + 5);
			      
			      // Agregar etiqueta "Código de Barras"
			      doc.setFontSize(8);
			      doc.setTextColor(100, 100, 100);
			      doc.text('Código:', barcodeX - 5, barcodeY - 8);
			    }

			    let y = 20;
			    doc.setFontSize(18);
			    doc.text(`Reporte de Conteo - ${device}`, 15, y);
			    y += 14;
			    doc.setFontSize(12);
			    doc.text(`Barcode: ${barcode}`, 15, y);
			    y += 8;
			    doc.text(`Inicio: ${inicio}`, 15, y);
			    y += 8;
			    doc.text(`Fin: ${fin}`, 15, y);
			    y += 8;
			    doc.text(`Duración: ${duration}`, 15, y);
			    y += 14;

			    // Tabla de totalizadores
			    const tableBody = totalizers.map(t => [
			      t.tag ? String(t.tag).toUpperCase() : '',
			      t.in != null ? String(t.in) : '',
			      t.out != null ? String(t.out) : ''
			    ]);
			    autoTable(doc, {
			      head: [["TAG", "IN", "OUT"]],
			      body: tableBody,
			      startY: y,
			      headStyles: { fillColor: [255,255,255], textColor: [0,0,0], fontStyle: 'bold' },
			      bodyStyles: { textColor: [0,0,0] },
			      styles: { halign: 'center', fontSize: 12 },
			      theme: 'grid',
			    });

			    // Nombre del archivo
			    const safeDevice = device ? String(device).replace(/[^a-zA-Z0-9_\-]/g, "") : "device";
			    const safeBarcode = barcode ? String(barcode).replace(/[^a-zA-Z0-9_\-]/g, "") : "barcode";
			    const filename = `conteo_${safeDevice}_${safeBarcode}.pdf`;
			    doc.save(filename);
			  }).catch(err => {
			    console.error('Error al generar el PDF:', err);
			    this.$EventBus && this.$EventBus.$emit('notifications_modal', {
			      type: 'error',
			      message: 'Error al generar el PDF'
			    });
			  });
			},

			downloadRowVideo(item) {
			  console.log('📹 [VIDEO-DOWNLOAD] Descargando video evidence para:', item.barcode);
			  
			  if (!item.barcode) {
			    this.$EventBus && this.$EventBus.$emit('notifications_modal', {
			      type: 'error',
			      message: this.$ml.get('barcode_not_found') || 'No se encontró código de barras para este evento'
			    });
			    return;
			  }
			  
			  // Construir la URL de la API
			  const videoUrl = `${this.$URL}/api/v1/operationsession/video/${item.barcode}`;
			  console.log('📹 [VIDEO-DOWNLOAD] URL del video:', videoUrl);
			  
			  // Abrir el video en una nueva página
			  window.open(videoUrl, '_blank');
			},

			// Método para limpiar memoria y optimizar rendimiento
			cleanupMemory() {
				// Limpiar eventos antiguos si hay demasiados
				if (this.list.length > 100) {
					const eventKeys = Object.keys(this.eventosPorId);
					const keysToRemove = eventKeys.slice(0, 50); // Mantener solo los últimos 50
					
					keysToRemove.forEach(key => {
						delete this.eventosPorId[key];
					});
					
					// Limpiar la lista también
					this.list = this.list.slice(0, 50);
					console.log('📊 [MEMORY] Cleaned up old events, remaining:', this.list.length);
				}
			},

			// Método para limpiar duplicados existentes en la lista
			cleanupDuplicates() {
				if (this.ref === 'counter') {
					// Para counter, usar barcode como identificador único
					const seen = new Set();
					const uniqueList = this.list.filter(item => {
						const barcode = item.barcode;
						if (!barcode || seen.has(barcode)) {
							return false;
						}
						seen.add(barcode);
						return true;
					});
					
					if (uniqueList.length !== this.list.length) {
						console.log('📊 [CLEANUP] Removed', this.list.length - uniqueList.length, 'duplicate barcodes');
						this.list = uniqueList;
					}
				} else {
					// Para otros tipos, usar id como identificador único
					const seen = new Set();
					const uniqueList = this.list.filter(item => {
						const id = item.id;
						if (!id || seen.has(id)) {
							return false;
						}
						seen.add(id);
						return true;
					});
					
					if (uniqueList.length !== this.list.length) {
						console.log('📊 [CLEANUP] Removed', this.list.length - uniqueList.length, 'duplicate IDs');
						this.list = uniqueList;
					}
				}
			},

			// Método para optimizar el procesamiento de eventos
			optimizeEventProcessing(message) {
				// Verificar si el mensaje es válido antes de procesarlo
				if (!message || typeof message !== 'object') {
					return false;
				}
				
				// Limitar el procesamiento si hay demasiados eventos pendientes
				if (this.list.length > 500) {
					console.warn('📊 [MEMORY] Demasiados eventos en lista, limpiando...');
					this.cleanupMemory();
					return false;
				}
				
				return true;
			},

			// Método para actualizar la fecha en el modelo local
			updateCounterDate(item, field) {
				if (this.ref !== 'counter' || !item || !field) return;
				
				console.log(`📊 [COUNTER-EDIT] Actualizando ${field} para item:`, item.barcode, 'valor:', item[field]);
				
				// Convertir el valor del input datetime-local a formato ISO
				if (item[field]) {
					const date = new Date(item[field]);
					if (!isNaN(date.getTime())) {
						item[field] = this.$Format.momentz(date).format('YYYY-MM-DD HH:mm:ss');
						console.log(`📊 [COUNTER-EDIT] Fecha convertida:`, item[field]);
					}
				}
			},

			// Método para guardar la fecha en el backend
			async saveCounterDate(item, field) {
				if (this.ref !== 'counter' || !item || !field) return;
				// Validación extra para evitar doble click
				if ((field === 'fin' && (item.saving_fin || item.state === 'Finalizado'))) return;
				
				// Activar loading
				this.$set(item, `saving_${field}`, true);
				
				try {
					console.log(`📊 [COUNTER-SAVE] Guardando ${field} para item:`, item.barcode);
					console.log(`📊 [COUNTER-SAVE] Item completo:`, item);
					console.log(`📊 [COUNTER-SAVE] deviceId disponible:`, item.deviceId);
					
					// Preparar los datos para el backend
					const updateData = {
						barcode: item.barcode,
						deviceId: item.deviceId || item.device_name,
						state: item.fin ? 2 : 1 // 1 = en progreso, 2 = finalizado
					};
					
					console.log(`📊 [COUNTER-SAVE] Datos a enviar:`, updateData);
					console.log(`📊 [COUNTER-SAVE] deviceId final:`, updateData.deviceId);
					console.log(`📊 [COUNTER-SAVE] item.deviceId:`, item.deviceId);
					console.log(`📊 [COUNTER-SAVE] item.device_name:`, item.device_name);
					
					// Agregar las fechas según el campo que se está editando
					if (field === 'inicio' && item.inicio) {
						const startDate = new Date(item.inicio);
						updateData.timestamp_start = startDate.getTime();
					}
					
					if (field === 'fin' && item.fin) {
						const endDate = new Date(item.fin);
						updateData.timestamp_end = endDate.getTime();
					}
					
					// Si se está editando la fecha de fin, recalcular la duración
					if (field === 'fin' && item.inicio && item.fin) {
						const startTime = new Date(item.inicio);
						const endTime = new Date(item.fin);
						const durationMs = endTime - startTime;
						
						if (durationMs > 0) {
							const hours = Math.floor(durationMs / (1000 * 60 * 60));
							const minutes = Math.floor((durationMs % (1000 * 60 * 60)) / (1000 * 60));
							const seconds = Math.floor((durationMs % (1000 * 60)) / 1000);
							
							item.duration = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
						}
					}
					
					// Hacer la petición PUT al backend
					const api = this.$URL + '/api/v1/operationsession/' + item.id;
					const response = await this.$axios.put(api, updateData);
					
					if (response && response.status === 200) {
						console.log(`📊 [COUNTER-SAVE] ${field} guardado exitosamente`);
						
						// Mostrar notificación de éxito
						this.$EventBus.$emit('notifications_modal', {
							type: 'success',
							message: `Fecha de ${field === 'inicio' ? 'inicio' : 'fin'} actualizada correctamente`
						});
						
						// Actualizar el estado visual si es necesario
						if (field === 'fin' && item.fin) {
							item.state = 'Finalizado';
							item.state_icon = 'mdi-check-circle';
						}
						
						// Desactivar modo edición
						this.$set(item, `editing_${field}`, false);
						
						// Limpiar valores originales
						if (item.original_values && item.original_values[field]) {
							delete item.original_values[field];
						}
						
						// Forzar actualización de la tabla
						// No forzar actualización: el item ya es reactivo
						
					} else {
						throw new Error('Respuesta inesperada del servidor');
					}
					
				} catch (error) {
					console.error(`❌ [COUNTER-SAVE] Error guardando ${field}:`, error);
					
					// Mostrar notificación de error
					this.$EventBus.$emit('notifications_modal', {
						type: 'error',
						message: `Error al actualizar fecha de ${field === 'inicio' ? 'inicio' : 'fin'}`
					});
					
					// Revertir el cambio en caso de error
					this.get_list(); // Recargar datos del servidor
				} finally {
					// Desactivar loading
					this.$set(item, `saving_${field}`, false);
				}
			},

			// Método para formatear fecha para input datetime-local
			formatDateForInput(dateString) {
				if (!dateString) return '';
				try {
					const date = new Date(dateString);
					if (isNaN(date.getTime())) return '';
					
					// Formato YYYY-MM-DDTHH:mm para datetime-local
					const year = date.getFullYear();
					const month = String(date.getMonth() + 1).padStart(2, '0');
					const day = String(date.getDate()).padStart(2, '0');
					const hours = String(date.getHours()).padStart(2, '0');
					const minutes = String(date.getMinutes()).padStart(2, '0');
					
					return `${year}-${month}-${day}T${hours}:${minutes}`;
				} catch (error) {
					console.error('Error formateando fecha:', error);
					return '';
				}
			},

			// Método para iniciar la edición de una fecha
			startEditDate(item, field) {
				if (this.ref !== 'counter' || !item || !field) return;
				
				console.log(`📊 [COUNTER-EDIT] Iniciando edición de ${field} para item:`, item.barcode);
				
				// Guardar el valor original para poder cancelar
				if (!item.original_values) {
					item.original_values = {};
				}
				item.original_values[field] = item[field];
				
				// Activar modo edición
				this.$set(item, `editing_${field}`, true);
			},

			// Método para cancelar la edición de una fecha
			cancelEditDate(item, field) {
				if (this.ref !== 'counter' || !item || !field) return;
				
				console.log(`📊 [COUNTER-EDIT] Cancelando edición de ${field} para item:`, item.barcode);
				
				// Restaurar valor original
				if (item.original_values && item.original_values[field] !== undefined) {
					item[field] = item.original_values[field];
				}
				
				// Desactivar modo edición
				this.$set(item, `editing_${field}`, false);
			},

			// Método para obtener la clave única de un item
			getItemKey(item) {
				if (!item) return null;
				
				// Para counter events, usar id si existe, sino barcode
				if (this.ref === 'counter') {
					return item.id || item.barcode || `counter_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
				}
				
				// Para otros tipos de eventos, usar id o tracker_id
				return item.id || (item.item && item.item.tracker_id) || `event_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
			},

			// Método para manejar actualizaciones de fechas desde parking.vue
			handleParkingDateUpdate(data) {
				if (!data || !data.barcode) return;
				
				console.log('📊 [PARKING-DATE-UPDATE] Procesando actualización de fecha:', data);
				
				// Buscar el item en la lista por barcode
				const itemIndex = this.list.findIndex(item => item.barcode === data.barcode);
				if (itemIndex >= 0) {
					const item = this.list[itemIndex];
					const updated = { ...item };
					
					// Actualizar las fechas si están presentes en los datos
					if (data.timestamp_start) {
						const startDate = new Date(data.timestamp_start);
						updated.inicio = this.formatDateForInput(startDate.toISOString());
					}
					
					if (data.timestamp_end) {
						const endDate = new Date(data.timestamp_end);
						updated.fin = this.formatDateForInput(endDate.toISOString());
					}
					
					// Recalcular duración si ambas fechas están presentes
					if (updated.inicio && updated.fin) {
						const startTime = new Date(updated.inicio);
						const endTime = new Date(updated.fin);
						const durationMs = endTime - startTime;
						
						if (durationMs > 0) {
							const hours = Math.floor(durationMs / (1000 * 60 * 60));
							const minutes = Math.floor((durationMs % (1000 * 60 * 60)) / (1000 * 60));
							const seconds = Math.floor((durationMs % (1000 * 60)) / 1000);
							
							updated.duration = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
						}
					}
					
					// Actualizar estado si está presente
					if (data.state !== undefined) {
						updated.state = data.state;
					}

					// Reemplazar por splice para asegurar reactividad en Vue2 sin $forceUpdate
					this.list.splice(itemIndex, 1, updated);
					console.log('📊 [PARKING-DATE-UPDATE] Item actualizado:', updated);
				}
			},

			// Método para manejar actualizaciones de sesiones de operación desde WebSocket
			handleOperationSessionUpdate(data) {
				if (!data || !data.sessionData) return;
				
				console.log('📊 [WEBSOCKET-SESSION-UPDATE] Procesando actualización de sesión:', data);
				
				const { sessionData } = data;
				
				// Buscar el item en la lista por barcode
				const itemIndex = this.list.findIndex(item => item.barcode === sessionData.barcode);
				if (itemIndex >= 0) {
					const item = this.list[itemIndex];
					const updated = { ...item };
					
					// Actualizar las fechas si están presentes en los datos
					if (sessionData.timestamp_start) {
						const startDate = new Date(sessionData.timestamp_start);
						updated.inicio = this.formatDateForInput(startDate.toISOString());
					}
					
					if (sessionData.timestamp_end) {
						const endDate = new Date(sessionData.timestamp_end);
						updated.fin = this.formatDateForInput(endDate.toISOString());
					}
					
					// Recalcular duración si ambas fechas están presentes
					if (updated.inicio && updated.fin) {
						const startTime = new Date(updated.inicio);
						const endTime = new Date(updated.fin);
						const durationMs = endTime - startTime;
						
						if (durationMs > 0) {
							const hours = Math.floor(durationMs / (1000 * 60 * 60));
							const minutes = Math.floor((durationMs % (1000 * 60 * 60)) / (1000 * 60));
							const seconds = Math.floor((durationMs % (1000 * 60)) / 1000);
							
							updated.duration = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
						}
					}
					
					// Actualizar estado si está presente
					if (sessionData.state !== undefined) {
						updated.state = sessionData.state;
					}
					
					// Actualizar totalizers si están presentes
					if (sessionData.totalizer && Array.isArray(sessionData.totalizer)) {
						updated.totalizers = sessionData.totalizer;
					}

					this.list.splice(itemIndex, 1, updated);
					console.log('📊 [WEBSOCKET-SESSION-UPDATE] Item actualizado:', updated);
					
					// Mostrar notificación de éxito
					this.$EventBus.$emit('notifications_modal', {
						type: 'success',
						message: `Sesión actualizada en tiempo real: ${sessionData.barcode}`
					});
				} else {
					console.log('📊 [WEBSOCKET-SESSION-UPDATE] No se encontró item con barcode:', sessionData.barcode);
				}
			},
			// ── Technical table UX methods ──

			// Classify a tag string into 'error' | 'warning' | 'ok' | 'unknown'
			tech_severity(tag) {
				const t = (tag || '').toLowerCase();
				if (t.includes('error') || t.includes('disconnect') || t.includes('fail') || t.includes('offline')) return 'error';
				if (t.includes('reconnect') || t.includes('warning') || t.includes('retry')) return 'warning';
				if (t.includes('connect') || t.includes('online') || t.includes('ok') || t.includes('success')) return 'ok';
				return 'unknown';
			},

			// Accumulate rows into the persistent tech_camera_status map.
			// Called by the list watcher and only processes each camera if the row
			// is more recent than what we already know (or if it's new).
			tech_update_status_from_list(rows) {
				(rows || []).forEach(row => {
					if (!row || !row.device) return;
					const key = row.device;
					const existing = this.tech_camera_status[key];
					const rowMs = row.createdAt ? new Date(row.createdAt).getTime() : 0;
					const existingMs = existing ? (existing.createdAt ? new Date(existing.createdAt).getTime() : 0) : -1;
					if (!existing) {
						this.$set(this.tech_camera_status, key, {
							name      : row.device,
							deviceId  : row.deviceId || row.device,
							tag       : row.tag,
							createdAt : row.createdAt,
							count     : 1,
							severity  : this.tech_severity(row.tag),
						});
					} else {
						// Update status if this row is newer; always increment count
						const updated = { ...existing, count: existing.count + 1 };
						if (rowMs >= existingMs) {
							updated.tag      = row.tag;
							updated.createdAt = row.createdAt;
							updated.severity  = this.tech_severity(row.tag);
						}
						this.$set(this.tech_camera_status, key, updated);
					}
				});
			},

			// ── Estado AUTORITATIVO del panel técnico (no depende del feed de eventos) ──
			// Severidad a partir del estado real del dispositivo en workspace/state.
			tech_state_severity(s) {
				if (!s) return 'unknown';
				// Cada módulo (rtsp, record, ping, retransmission_*, ...) trae su propia
				// clasificación en `color` ('success'/'warning'/'error'). Tomamos la peor.
				let worst = 'unknown';
				Object.keys(s).forEach(k => {
					// 'not_found' = código técnico no reconocido por el backend; no es un error real
					// del dispositivo, así que no debe clasificarlo como crítico.
					if (k === 'not_found') return;
					const m = s[k];
					if (m && typeof m === 'object' && m.color) {
						if (m.color === 'error') worst = 'error';
						else if (m.color === 'warning' && worst !== 'error') worst = 'warning';
						else if ((m.color === 'success' || m.color === 'primary') && worst !== 'error' && worst !== 'warning') worst = 'ok';
					}
				});
				if (worst === 'unknown') {
					if (s.error === true) return 'error';
					if (s.error === false) return 'ok';
				}
				return worst;
			},
			// Reconstruye el mapa de estado desde la lista REAL de dispositivos + workspace/state.
			// Siembra TODOS los dispositivos (siempre presentes => no aparecen/desaparecen).
			tech_load_workspace_state() {
				if (this.ref !== 'technical') return;
				const devices = this.list_devices || [];
				const next = {};
				devices.forEach(d => {
					if (!d || !d.deviceId) return;
					next[d.deviceId] = {
						deviceId  : d.deviceId,
						name      : d.name || d.deviceId,
						severity  : 'unknown',
						count_err : 0,
					};
				});
				// Mostrar las cámaras de inmediato (en 'unknown') antes de la primera respuesta
				if (!Object.keys(this.tech_camera_status).length) {
					this.tech_camera_status = { ...next };
				}
				this.$axios.post(this.$URL + '/api/v1/workspace/state', { manager_id: 'my_computer' })
					.then(res => {
						const st = res && res.data && res.data.states && res.data.states.devices
							? res.data.states.devices : {};
						Object.keys(st).forEach(devId => {
							const s = st[devId];
							const entry = next[devId] || { deviceId: devId, name: (s && s.name) || devId };
							entry.severity  = this.tech_state_severity(s);
							entry.count_err = (s && s.count_err) || 0;
							if (s && s.name) entry.name = s.name;
							// Extraer bitrate, resolución y canal de la retransmisión cloud
							const rc = s && (s.retransmission_cloud || s.retransmission);
							if (rc) {
								entry.bitrate_kbps = rc.bitrate_kbps || null;
								entry.resolution   = rc.resolution   || null;
								entry.cloud_channel = rc.channel      || null;
							}
							next[devId] = entry;
						});
						this.tech_camera_status = next;
					})
					.catch(() => {
						// Si falla, al menos dejar las cámaras sembradas en 'unknown'
						if (!Object.keys(this.tech_camera_status).length) this.tech_camera_status = next;
					});
			},
			tech_start_state_polling() {
				this.tech_load_workspace_state();
				if (this.tech_state_interval) clearInterval(this.tech_state_interval);
				this.tech_state_interval = setInterval(() => {
					this.tech_load_workspace_state();
				}, 10000);
			},
			tech_stop_state_polling() {
				if (this.tech_state_interval) {
					clearInterval(this.tech_state_interval);
					this.tech_state_interval = null;
				}
			},

			tech_filter_camera(cam) {
				if (this.tech_filtered_device && this.tech_filtered_device.deviceId === cam.deviceId) {
					this.tech_filtered_device = null;
				} else {
					this.tech_filtered_device = cam;
					this.tech_filtered_status = null; // camera filter takes priority
				}
			},
			tech_filter_status(status) {
				this.tech_filtered_device = null;
				this.tech_filtered_status = (this.tech_filtered_status === status) ? null : status;
			},
			tech_clear_filter() {
				this.tech_filtered_device = null;
				this.tech_filtered_status = null;
			},
			tech_open_drawer(cam) {
				this.tech_drawer_camera = cam;
				this.tech_drawer_list   = [];
				this.tech_drawer_page   = 1;
				this.tech_drawer_total  = 0;
				this.tech_drawer_open   = true;
				this.tech_load_drawer_history();
			},
			tech_load_drawer_history() {
				if (!this.tech_drawer_camera) return;
				this.tech_drawer_loading = true;
				const name    = this.tech_drawer_camera.name || this.tech_drawer_camera.deviceId;
				const perPage = 30;
				const offset  = (this.tech_drawer_page - 1) * perPage;
				const rows = (this.list || []).filter(r => r && r.device === name).slice();
				this.tech_drawer_total = rows.length;
				rows.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
				const page_rows = rows.slice(offset, offset + perPage);
				if (this.tech_drawer_page === 1) {
					this.tech_drawer_list = page_rows;
				} else {
					this.tech_drawer_list = this.tech_drawer_list.concat(page_rows);
				}
				this.tech_drawer_loading = false;
			},
			tech_load_more_drawer() {
				this.tech_drawer_page++;
				this.tech_load_drawer_history();
			},
			tech_state_color(tag) {
				const sev = this.tech_severity(tag);
				return { error: 'error', warning: 'orange', ok: 'success', unknown: 'grey' }[sev] || 'grey';
			},

			get_item_event_id(item) {
				if (!item) return null;
				// Top-level id is the original event PK used as correlator
				return item.id != null ? String(item.id) : null;
			},

			get_item_cloud_status(item) {
				const eid = this.get_item_event_id(item);
				return eid ? (this.cloud_status_map[eid] || null) : null;
			},

			// Marca un evento recién llegado en vivo como 'pending' (naranja) de inmediato,
			// para que el indicador "no subido al cloud" aparezca sin esperar un refresh.
			// El WS 'cloud_sent' luego lo pasa a 'sent' (verde). No pisa un estado ya conocido.
			mark_cloud_pending(item) {
				const eid = this.get_item_event_id(item);
				if (eid && !this.cloud_status_map[eid]) {
					this.$set(this.cloud_status_map, eid, 'pending');
				}
			},

			fetch_cloud_status(rows) {
				const tabs = ['alarms', 'smart_event', 'avc', 'lpr', 'objects'];
				if (!tabs.includes(this.ref)) return;
				const ids = (rows || [])
					.map(r => r && r.id != null ? String(r.id) : null)
					.filter(Boolean);
				if (!ids.length) return;
				const unique = [...new Set(ids)];
				const api = this.$URL + '/api/v1/admin/queue/cloud-status?ids=' + unique.join(',');
				axios.get(api).then(res => {
					const results = (res.data && res.data.results) || {};
					const map = { ...this.cloud_status_map };
					for (const [eid, info] of Object.entries(results)) {
						map[eid] = info.is_sent ? 'sent' : 'pending';
					}
					this.cloud_status_map = map;
				}).catch(() => {});
			},
		}, //methods

		mounted(){
			this.onResize();

			let vm = this;

			vm.$nextTick( ()=>{
				vm.onResize();

				/*this.list.push(this.info_format(test[0],'lpr'));
				this.total = 1;*/
			})

			// Sync counter with backend if this is a counter component
			if (this.ref === 'counter') {
				// Ejecutar sincronización de forma asíncrona sin bloquear la inicialización
				this.syncCounterTimeout = setTimeout(() => {
					this.syncCounterWithBackend().catch(error => {
						console.warn('📊 [SYNC] Sync failed, continuing without backend sync:', error);
					});
				}, 1000); // Esperar 1 segundo antes de sincronizar
			}

			let ev = this;

			// Escuchar evento para sincronizar contadores de parking
			EventBus.$on('sync_parking_counters', ev.bus_channels['sync_parking_counters'] = (data) => {
				if (data && data.deviceIds && Array.isArray(data.deviceIds)) {
					// console.log('📊 [SYNC-REQUEST] Sincronización solicitada para dispositivos:', data.deviceIds);
					this.syncCounterWithBackend().catch(error => {
						console.warn('📊 [SYNC-REQUEST] Sync failed:', error);
					});
				}
			});

			// Escuchar actualizaciones de contadores desde parking.vue
			EventBus.$on('parking_counter_updated', ev.bus_channels['parking_counter_updated'] = (data) => {
				if (this.ref === 'counter' && data) {
					console.log('📊 [PARKING-UPDATE] Recibida actualización de contador desde parking:', data);
					// Ya no llamar a updateCounterFromParking aquí. Solo CounterCell debe manejar este evento.
				}
			});

			// Escuchar eventos de inicio/fin de grabación desde parking.vue
			EventBus.$on('parking_recording_state_changed', ev.bus_channels['parking_recording_state_changed'] = (data) => {
				if (this.ref === 'counter' && data) {
					console.log('📊 [PARKING-RECORDING] Estado de grabación cambiado:', data);
					this.handleParkingRecordingStateChange(data);
				}
			});

			// Escuchar actualizaciones de fechas desde parking.vue
			EventBus.$on('parking_date_updated', ev.bus_channels['parking_date_updated'] = (data) => {
				if (this.ref === 'counter' && data) {
					console.log('📊 [PARKING-DATE-UPDATE] Fecha actualizada desde parking:', data);
					this.handleParkingDateUpdate(data);
				}
			});

			// Escuchar notificaciones WebSocket de actualización de sesiones de operación
			if (this.$socket) {
				this.operationSessionUpdateHandler = (data) => {
					console.log('📊 [WEBSOCKET-SESSION-UPDATE] Sesión actualizada:', data);

					if (this.ref === 'counter' && data && data.sessionData) {
						this.handleOperationSessionUpdate(data);
					}
				};
				this.$socket.on('operation_session_update', this.operationSessionUpdateHandler);
			}

			// Actualización en tiempo real del estado de envío a cloud
			const cloudTabs = ['alarms', 'smart_event', 'avc', 'lpr', 'objects'];
			EventBus.$on('cloud_sent', ev.bus_channels['cloud_sent'] = (data) => {
				if (data && data.event_id && cloudTabs.includes(this.ref)) {
					this.$set(this.cloud_status_map, String(data.event_id), 'sent');
				}
			});

			EventBus.$on('set_ref_events', ev.bus_channels['set_ref_events'] = (action)=>{
				if (action) {
					// console.log( "set table ", action)
					this.set_header(action, true);					
				}
			});

			let bus_keyboard = 'keyboard_type' + this.ID_notification; 
			EventBus.$on( bus_keyboard, ev.bus_channels[bus_keyboard] = (action) =>{
				if (action) {
					// console.log("INPUT TYPE : ",action)
					if (action.setting ) {
						let { obj, key, type, func } =  action.setting;
						if ( action.input || action.input == "") {

							if (type == 'text') {
								if (func == 'toUpperCase') {
									this[key] = action.input[func]();

								}else{
									this[key] = action.input;
								}
							}else{
								this[obj][key] = action.input;
								
							}
						}
						 
					}
				}
			});

			bus_keyboard = 'keyboard_type_button' + this.ID_notification;
			EventBus.$on(bus_keyboard , ev.bus_channels[bus_keyboard] = (action) =>{
				if (action) {
					if (action.setting ) {
						let { obj, key, type, func } =  action.setting;
						// console.log("SEARCH EVENT 1", action.button == "{enter}", type, key)

						if (action.button == '{enter}') {
							if (type == 'text' && key == 'search') {
								// console.log("SEARCH EVENT")
								this.get_search(this.search);
							}

						}
					}
				}
			})
			bus_keyboard = "update_table_" + 'management_events_' + this.layout_id; 
			EventBus.$on(bus_keyboard , ev.bus_channels[bus_keyboard] = (action) =>{				
				if (action && action.id) {
					let idx = this.list.findIndex( x => (x && x.id == action.id));					
					if (idx >= 0) {
						this.list[idx] = { ...this.list[idx], ...action };
						if (this.list[idx] && this.list[idx].formated) {
							this.list[idx].formated = { ...this.list[idx].formated, ...action };
						} 				
						this.list.splice(idx, 1, this.list[idx]);
					}
					
					let idx1 = this.list_search.findIndex( x => (x && x.id == action.id));					
					if (idx1 >= 0) {
						this.list_search[idx1] = { ...this.list_search[idx1], ...action };
						if (this.list_search[idx1] && this.list_search[idx1].formated) {
							this.list_search[idx1].formated = { ...this.list_search[idx1].formated, ...action };
						} 				
						this.list_search.splice(idx1, 1, this.list_search[idx1]);
					}
				}
			})

			this.is_loading_init = false;

			EventBus.$on(
				'relay_io_state_history',
				(ev.bus_channels['relay_io_state_history'] = msg => {
					this.onRelayIoStateHistorySocket(msg);
				})
			);
			
			// Limpiar duplicados existentes al inicializar
			this.$nextTick(() => {
				this.cleanupDuplicates();
			});
	     	// console.log(ev.list, 'events1')	     		     
		}, // mounted

		beforeDestroy(){
			let ev = this;
			this.tech_stop_state_polling();
			if (this.mixta_bus_handlers && Object.keys(this.mixta_bus_handlers).length) {
				Object.keys(this.mixta_bus_handlers).forEach((name) => {
					EventBus.$off(name, this.mixta_bus_handlers[name]);
				});
				this.mixta_bus_handlers = {};
			}
			for(let event_name in ev.bus_channels){
				if (ev.bus_channels && ev.bus_channels[event_name]) {
					EventBus.$off(event_name, ev.bus_channels[event_name]);
				}
			}
			if (this.current_bus_table && this.current_bus_table !== 'mixta_multi' && EventBus._events[this.current_bus_table]) {
				EventBus.$off(this.current_bus_table, this.bus_channels[this.current_bus_table]);
			}

			// Limpiar listener WebSocket de actualización de sesiones
			if (this.$socket) {
				if (this.operationSessionUpdateHandler) {
					this.$socket.off('operation_session_update', this.operationSessionUpdateHandler);
					this.operationSessionUpdateHandler = null;
				} else {
					this.$socket.off('operation_session_update');
				}
			}
			// cloud_sent se limpia automáticamente en el bucle de bus_channels

			// Limpieza de listeners de DOM (ejemplo: resize)
			window.removeEventListener('resize', this.onResize);

			// Limpieza de posibles timers
			if (this.timer) clearTimeout(this.timer);
			if (this.interval) clearInterval(this.interval);
			if (this.timeout) clearTimeout(this.timeout);
			if (this.timeMultiplesDevices) clearTimeout(this.timeMultiplesDevices);
			if (this.syncCounterTimeout) clearTimeout(this.syncCounterTimeout);
			if (this.relayIoHistoryRefreshTimer) {
				clearTimeout(this.relayIoHistoryRefreshTimer);
				this.relayIoHistoryRefreshTimer = null;
			}

			// Limpieza de canvas (chips visuales)
			const elements = document.querySelectorAll('[id$="draw"]');
			elements.forEach(el => {
				const ctx = el.getContext && el.getContext('2d');
				if (ctx) ctx.clearRect(0, 0, el.width, el.height);
			});
		}, // beforeDestroy
	};// export default
